function SitesCtrl($sce, $scope, $timeout, $state, $controller, IconsService, $location, $animate, GeneralUtilsService,
                   ZoneService, LocationService, EntityTypesService, SiteService, GeneralPropertiesService, StaticRangeTranslationService, TimeZoneService, FailoverConfigurationService, SocketUIService, UserContextService){

    var NA_MESSAGE = "(Not available in current site)";
    var noBandwidthOnLicenseMessage = 'License bandwidth is required';
    $scope.vSOCKET_MANAGEMENT_IP_NAME = 'Management IP';
    const DEFAULT_MANAGEMENT_IP_NAME = 'Web Management IP';

    $scope.LOCAL_IP_IN_NEW_SITE_TOOLTIP = "Make sure that the Local IP is the same as the LAN interface IP on the vSocket. The first three IP addresses are reserved by the VPC or VNET.";

    const dhGroupsList = [
                          {
                              name: '2 (1024bit)',
                              id: 'DH_2_MODP1024'
                          },{
                              name: '5 (1536bit)',
                              id: 'DH_5_MODP1536'
                          },{
                              name: '14 (2048bit)',
                              id: 'DH_14_MODP2048'
                          },{
                              name: '15 (3072bit)',
                              id: 'DH_15_MODP3072'
                          },{
                              name: '16 (4096bit)',
                              id: 'DH_16_MODP4096'
                          }
                      ];

    $controller('ConfigController', {$scope: $scope, $timeout: $timeout});

	$controller('PolicyFormCtrl', {$scope: $scope, $controller: $controller, $location: $location, $animate: $animate, $timeout: $timeout, $state: $state, IconsService: IconsService, GeneralUtilsService: GeneralUtilsService});

    $scope.ipAllocationProperties = {wasChanged : false};
    $scope.showEditSecPW = false;
    $scope.showEditPW = false;
//    $scope.site.singleWanBwMgmt = true;
    $scope.origQos = {};
    $scope.allowOveridePrimarySocket = false;
    $scope.ikeRouteConfiguration = {};
    $scope.ikeTestConnectionConfiguration = {};
    $scope.showItem = 'host';
    $scope.siteTypes = [];

    $scope.failoverConfigChanged = false;
    $scope.componentHasChanges = [];
    $scope.failoverConfig;
    $scope.accountId = $state.params.accountId;
    $scope.isEditor = UserContextService.isEditor();

    // TODO this is buggy in case user is faster than angular and presses some buttons before angular finished...
    SiteService.getConnectionTypes($state.params.accountId, function(data) {
        $scope.siteConnTypes = data.siteConnTypes;
    });

    $scope.gredatamodified = false; // GRE Tunnel
    $scope.configureEgressShowItem = 'custom';
    $scope.sitesUsage = {};
    $scope.states = {};
    $scope.allWan = {name: "All interfaces", interface_id: "ALL_WAN"};
    $scope.ipsecdatamodified = false; // IP SEC Tunnel
    $scope.ikeV2Properties = {
        showEditPW : false,
        showEditSecPW : false
    };
    $scope.validPasswordConfirm = false;

    var allocatedIps =[];

    /*
     * original site usages lists for the site
     * we want to save a copy since we are tempering with the
     * data when filtering the lists and wouldn't want to refetch it
    */
    var origSiteUsages;

    $scope.trialBandwithMessage = 'Selecting bandwidth is available in commercial mode';

    $scope.datamodified = false;
    $scope.hostsdatamodified = false;
    $scope.dnssettingsdatamodified = false;
    $scope.bypassdatamodified = false;
    $scope.portForwardingmodified = false;
    $scope.groupsDataModified = false;
    $scope.qosdatamodified = false;

    $scope.timezones = [];
    TimeZoneService.getTimeZones(function(timeZones) {
        $scope.timezones = timeZones;
    });

    /**
     *  enables the save button upon a change on the ip allocation properties
     */
    $scope.$watch('ipAllocationProperties.wasChanged', function(newValue, oldValue) {
        if (!_.isEqual(newValue, oldValue) && newValue && newValue == true) {
            $scope.configureEgressSaveEnabled = true;
        }

    }, true);

    $scope.$watch('site', function(){
        if($scope.site){
            setSingleWanQosPolicy();
        }
    });

    $scope.$root.hasChanges = function(){
        var site = $scope.site;
        if(!site) return false;
        if($scope.$root.errors['licenseError']) return false;
        if($scope.$root.errors['interval']) return false;
        if(site.id < 0) return true; //new site
        if(!angular.equals($scope.site,$scope.orig)) return true;
        if($scope.failoverConfigChanged) return true;
        if($scope.componentHasChanges.length > 0) return true;
        if(!angular.equals($scope.hostsConfig.items,$scope.hostsConfig.origItems)) return true;
        if(!angular.equals($scope.destBypassConfig.items,$scope.destBypassConfig.origItems)) return true;
        if(!angular.equals($scope.srcBypassConfig.items,$scope.srcBypassConfig.origItems)) return true;
        if(!angular.equals($scope.portForwardingConfig.items,$scope.portForwardingConfig.origItems)) return true;
        if ($scope.rulesConfig.items.some(function(item) {return $scope.rulesConfig.getStatus(item) != 'saved';})) return true;
        return false;
    };

    $scope.setMacAuthOverride = function() {
        if ($scope.site.socketConnectionConfiguration && $scope.site.socketConnectionConfiguration.isMacAuthOverride == false) {
            $scope.site.socketConnectionConfiguration.macAddressAuthenticationEnabled = $scope.site.socketConnectionConfiguration.macAddressAuthenticationEnabledOnAccount;
        }
    }

    $scope.failoverConfigChangedListener = function(current, previous) {
		if(!angular.equals(current, previous)) {
			$scope.failoverConfigChanged = true;
		} else{
			$scope.failoverConfigChanged = false;
		}
		$scope.failoverConfig = current;
	}

    $scope.componentConfigChangedListener = function(componentName, current, hasChanges) {
        $scope.componentHasChanges[componentName] = hasChanges;
        $scope.site[componentName] = current;
    }

    initDataModifiersWatchers();

    $scope.openConnectivityChart = function(siteId){
        return function(){
            $scope.siteid = siteId;
        };
    };



    EntityTypesService.getSiteTypes($state.params.accountId, function(siteTypes) {
        siteTypes.forEach(function(siteType) {
            $scope.siteTypes.push(siteType);
        });
    });

    function setAllowGreTunnel(){
        if($scope.site && $scope.site.greRange.length > 0){
            $scope.site.allowGreTunnel = true;
        }
    }

//    function setAllowIpsecTunnel(){
//        if($scope.site && $scope.site.ipSec.length > 0){
//            $scope.site.allowIpSecTunnel = true;
//        }
//    }

    /**
     * function for initiate the configureEgressSaveEnabled which
     * states if the save button will be enabled
     */
    function initiateConfigureEgressSaveEnabled() {
        $scope.configureEgressSaveEnabled = false;
    }

    $scope.openAddNetworkRangeDlg = function(){
        $scope.interfacesShowItem ='custom';
        $scope.$root.openPopup('addNetworkRange');

    };

    /**
     * close the dialog  without saving and if changes were made
     * revert them
     **/
    $scope.closeConfigureEgressDlg = function(){
        if($scope.ipAllocationProperties ){
            $scope.ipAllocationProperties.reloadIpAllocationConfiguration = true;
        }

        // since we pressed cancel we revert the change
        $scope.configureEgressSaveEnabled = false;

        $scope.$root.closePopup('configureEgress');
    };

    /**
     * this callback weill be invoked when user clicks on the X button near a network range
     * cause to delete the network range
     **/
    $scope.onNetworkRangeRemove = function(){
        if($scope.site.ike){
            $scope.customIps ="";
            $scope.networkRanges.forEach(function(networkRange){
                if(networkRange.display_name){
                    $scope.customIps = $scope.customIps+","  +networkRange.display_name;
                }
                else{
                    $scope.customIps = $scope.customIps+","  +networkRange;
                }
            });
            $scope.customIps= $scope.customIps.substring(1,$scope.customIps.length);
        }
        $scope.addNetworkRange();
    };


    /**
     * callback egress saved , ip forwarding rules will be reloaded and the first rule will be
     * applied to the primary IPSec egress
     **/
    $scope.onEgressSave = function(){
        loadAllocatedIps();
    };

    function updateSelectedSecondaryEgress(){
        if($scope.site && $scope.site.ike && $scope.secondaryIpForwardingOptions && $scope.site.ike.secondaryLocalAddress){
            var foundCurrentIp = false;
            $scope.secondaryIpForwardingOptions.forEach(function(forwardingIp){
                if(forwardingIp.ip === $scope.site.ike.secondaryLocalAddress.ip){
                    foundCurrentIp = true;
                }
            });
            // meaning the selected ip isn't available anymore
            if(!foundCurrentIp){
                $scope.site.ike.secondaryLocalAddress = null;
            }
        }

    }

    /**
     * enrichment of the location on the allocated ip
     * @param items
     */
    function enrichAllocatedIps(items) {
        if(items){
            items.forEach(function (item) {
                enrichSingleAllocatedIp(item);
            });
        }
    }

    /**
     * enrichment of the location on a single allocated ip
     * @param allocatedIp
     */
    function enrichSingleAllocatedIp(allocatedIp) {
        if(!allocatedIp.displayName){
            var locationName = LocationService.getPopLocationViaLocationId($state.params.accountId,allocatedIp.locationId);
            allocatedIp.displayName = locationName? (locationName.name + ' - '+ allocatedIp.ip): ('Allocated IP - '+ allocatedIp.ip);
        }
    }

    function loadAllocatedIps(onSuccess) {
        if($scope.site){
            store.fetch({
                path: '/fetchAllocatedIps?accountId=' + $state.params.accountId,
                queryParams: {
                    accountId: $state.params.accountId
                },
                success: function (items) {
                    enrichAllocatedIps(items);
                    allocatedIps = items;
                    $scope.primaryIpForwardingOptions = [];
                    $scope.secondaryIpForwardingOptions = [];
                    items.forEach(function (allocatedIp) {
                        if (ikeDefined() && $scope.site.ike.primaryLocalAddress && allocatedIp.id === $scope.site.ike.primaryLocalAddress.id) {
                            $scope.site.ike.primaryLocalAddress.displayName = allocatedIp.displayName;
                            $scope.orig.ike.primaryLocalAddress.displayName = allocatedIp.displayName; // prevent fail positive diff detection on save
                            $scope.primaryIpForwardingOptions.push($scope.site.ike.primaryLocalAddress);
                        } else {
                            $scope.primaryIpForwardingOptions.push(allocatedIp);
                        }
                        if (ikeDefined() && $scope.site.ike.secondaryLocalAddress && allocatedIp.ip === $scope.site.ike.secondaryLocalAddress.ip) {
                            $scope.site.ike.secondaryLocalAddress.displayName = allocatedIp.displayName;
                            $scope.orig.ike.secondaryLocalAddress.displayName = allocatedIp.displayName; // prevent fail positive diff detection on save
                            $scope.secondaryIpForwardingOptions.push($scope.site.ike.secondaryLocalAddress);
                        } else {
                            $scope.secondaryIpForwardingOptions.push(allocatedIp);
                        }
                    });
                    updateSelectedSecondaryEgress();
                    if (onSuccess) {
                        onSuccess();
                    }
                }
            });
        }
    }


    function ikeDefined() {
        return $scope.site && $scope.site.ike
    }

    function initEgressOptions() {
        loadAllocatedIps();
    }

    function openAddSiteDlg() {
        $scope.$broadcast('confirmpw-clearPw')
        $scope.clearErrors();
        $scope.$root.openPopup('addSiteDlg');
    }

    store.fetch({
        method: 'POST',
        path: "/isDhcpRelayEnabled",
        queryParams :{
            accountId: $state.params.accountId
        },
        success: function(data) {
            $scope.dhcprelayenabled = data;
        }
    });

    /**
     * received a save command from configureEgress thus broadcasting an event to
     * the egressConfig directive for initiating a save command
     **/
    $scope.saveEgress = function(){
        $scope.ipAllocationProperties.saveEgress(function () {
            $scope.onEgressSave();
            $scope.$root.closePopup('configureEgress');
            $scope.configureEgressSaveEnabled = false;
            if($scope.site && $scope.site.siteConnType.protoType === 'IPSEC_V2'){
                $scope.ikeV2Properties.reload = true;
            }

        },function () {
            $scope.loading = false;
            $scope.configureEgressSaveEnabled = true;
        });
    };

    /**
     * opening the configure egress dialog
     **/
    $scope.openEgressDlg = function(){
        $scope.$root.openPopup('configureEgress');
    };


    function getIke() {
        if($scope.site.ike){
            return $scope.site.ike;
        }
        if($scope.site.ikeV2){
            return $scope.site.ikeV2;
        }
    }

    /**
     * opens a popup dialog indicating to the user that the site is currently connected
     * and proceeding with saving action will cause a disconnection from the POP
     **/
    $scope.openDisconnectingSitePopup = function(){
        var message = "Changing the country or state of an online site will cause a momentarily disconnection to Cato. Click OK to proceed.";
        $scope.$root.confirm(message,function(){
            $scope.editSite();
        });
    };


    $scope.saveChanges = function(){
        // only if state or country changes pop dialog
        if($scope.site && $scope.site.siteConnType.socketModelTypeConfiguration && (($scope.site.countryRaw != $scope.orig.countryRaw) || ($scope.site.stateRaw != $scope.orig.stateRaw && ($scope.site.stateRaw === '' && !$scope.orig.stateRaw)))){
            // build URL for checking if the current site is connected
            var url = "/isSiteConnected";
            store.fetch({
                method : 'GET',
                queryParams :{
                    accountId: $scope.accountId,
                    protoId: $scope.site.protoId
                },
                url : url ,
                success: function(data) {
                    // the site is connected
                    if(data){
                        $scope.openDisconnectingSitePopup();
                    }
                    // the site isn't connected
                    else{
                        $scope.editSite();
                    }
                },
                error: function() {
                    // got an error while executing GET request
                    // open dialog
                    $scope.openDisconnectingSitePopup();
                }
            });
        }
        else{
            $scope.editSite();
        }
    };

    //receive deleted items and add them to ItemsToDelete
    $scope.deleteItems = function(items, propertyName){
       GeneralUtilsService.addItemsToDelete($scope.site, items, propertyName);
    };

    // init watcher for deep watching (workaround for Angular bug)
    function initDataModifiersWatchers() {

        $scope.interfacehostsdatamodified = {};
        for (var i=0; i < 4; i++) {
            $scope.interfacehostsdatamodified['interfacehostsdatamodified' + i] = false;
        }
    }

//    function setShowMultiTunnelMode(site) {
//        $scope.showMultiTunnelMode = site.siteConnType.socketModelTypeConfiguration ? true : false;
//    }

    function setSingleWanQosPolicy(){

        if ($scope.site.singleWanQosPolicy==false) {
            $scope.site.singleWanBwMgmt = false;
        }
        else
            $scope.site.singleWanBwMgmt = true;
    }

    $scope.updateConnectionType = function(site) {
        if (SiteService.siteHasSocketAddOn(site)) {
            $scope.addOns = site.socketConnectionConfiguration.socketsSettings.primary.supportedAddOns;
            site.socketAddOnType = site.socketConnectionConfiguration.socketsSettings.primary.addOn;
        }
        else {
            $scope.addOns = null;
            if ($scope.orig && $scope.orig.socketAddOnType && site.id === $scope.orig.id)
                site.socketAddOnType = $scope.orig.socketAddOnType;
        }

        setSDWAN(site);

        if (site) {
            // if we changed to Cato initiated IPSec we load default values
            if (site.siteConnType.protoType === 'IPSEC_HOST') {
                setIkev1DefaultValues();
            } else if (site.siteConnType.protoType === 'IPSEC_CLIENT') {
                if(!site.ipSecMode)
                    site.ipSecMode = 'MAIN'
            }
            else if(site.siteConnType.protoType == 'IPSEC_V2') {
                setIKEV2DefaultValues()
                if($scope.ikeV2Properties){
                    $scope.ikeV2Properties.reload = true;
                }
                else {
                    $scope.ikeV2Properties = {
                        showEditPW : false,
                        showEditSecPW : false,
                        reload: true
                    }
                }
            }
            else {
                delete site.ikeV2;
            }
        }
    }

    /*
     * When removing an add-on or changing to an add-on with less ports, we want to make sure that the ports that should be removed are set with Destination INTERFACE_DISABLED
     * A legal add-on change is either (adding a new add-on) or (changing to an add-on with more ports) or
     * (Changing to an add-on with less ports with removed port's destination set to INTERFACE_DISABLED) or
     * (removing an add-on with removed port's destination set to INTERFACE_DISABLED)
     *
     * If the change is legal we continue to updateAddOnType
     * else a prompt appears explaining to the user what should be done
     */
    $scope.updateAddOnTypeIfChangeIsLegal = function(site, newAddOnType, oldAddOnType){
        let numberOfNewAddOnPorts = newAddOnType?.numberOfPorts;
        let numberOfOldAddOnPorts = oldAddOnType?.numberOfPorts;
        let numberOfPortsWithNoAddOn = 8;

        if (numberOfNewAddOnPorts >= numberOfOldAddOnPorts){
            $scope.updateAddOnType(site, newAddOnType);
        } else {
            let numberOfCurrentPorts = site.socketConnectionConfiguration.socketInterfaces.length;
            let numberOfNewPorts = numberOfPortsWithNoAddOn + numberOfNewAddOnPorts;
            let removedPortsDisabled = true;

            // At the moment only X1700 sockets can have an add-on
            // Any port that will be removed does not have destination set to INTERFACE_DISABLED we do not want to continue
            for (let i = numberOfNewPorts; i < numberOfCurrentPorts; i++){
                removedPortsDisabled = removedPortsDisabled && site.socketConnectionConfiguration.socketInterfaces[i].destType.value === "INTERFACE_DISABLED";
            }

            if (removedPortsDisabled){
                $scope.updateAddOnType(site, newAddOnType);
            }else{
                $scope.$root.alert("There are " + site.socketConnectionConfiguration.socketInterfaces.length + " ports enabled for this site, and this add-on supports " + numberOfNewPorts + " ports. Please disable the additional ports and then select this add-on again.");
                $scope.site.socketAddOnType = oldAddOnType;
            }
        }
    }

    $scope.updateAddOnType = function(site, addOnType) {
        site.socketAddOnType = addOnType;

        SiteService.getCatoSocketsData($state.params.accountId, site.id, site.siteConnType, $scope.site.socketAddOnType, false, site.socketConnectionConfiguration, function(data) {
            SiteService.mergeSiteSocketConnection(site, data);
            initBWManagementData();
            $scope.updateConnectionType(site);
        });
    }

    $scope.getConnectivityType = function(site) {
        SiteService.getCatoSocketsData($state.params.accountId, site.id, site.siteConnType, null, false, site.socketConnectionConfiguration, function(data) {
            SiteService.mergeSiteSocketConnection(site, data);
            initBWManagementData();
            $scope.updateConnectionType(site);
        });
    }

    $scope.updateConnectivityType = function(site) {

        var foundMigration = !$scope.site.socketConnectionConfiguration || _.find($scope.site.socketConnectionConfiguration.socketsSettings.primary.supportedMigrations, function(socketModelType) {
            return site.siteConnType.socketModelTypeConfiguration && socketModelType.value === site.siteConnType.socketModelTypeConfiguration.value;
        })

        if (!foundMigration) {
            $scope.$root.confirm("Changing to this connection type will cause loss of existing site configuration", function(){
                if (site.socketConnectionConfiguration)
                    site.socketConnectionConfiguration.socketsSettings = {};
                $scope.getConnectivityType(site);
            });
        } else {
            $scope.getConnectivityType(site);
        }
    };

    $scope.updateNewSiteConnectivityType = function(site) {
        site.socketConnectionConfiguration = {};
        site.socketConnectionConfiguration.socketsSettings = {}; // need to prevent back-end from walking the socket migration path.
        SiteService.getCatoSocketsData($state.params.accountId, null, site.siteConnType, null, $scope.enableSecondaryWAN.value, site.socketConnectionConfiguration, function(data) {
            SiteService.mergeNewSiteSocketConnection(site, data);
//            $scope.updateConnectionType(site);
        });
        $scope.localIpInSiteCreation = (site.siteConnType?.value === "VSOCKET_VGX_AWS" || site.siteConnType?.value === "VSOCKET_VGX_AZURE");
    };



    $scope.catoIPsecTypes = [
        {
            name: 'AWS',
            id: 'AWS'
        },
        {
            name: 'Azure',
            id: 'Azure'
        },
        {
            name: 'Generic',
            id: 'Generic'
        }
    ];

    // IkeV1
    $scope.ciphersPhase1 = [
        {
            name: 'AES-CBC-128',
            id: 'AES_CBC_128'
        },{
            name: 'AES-CBC-256',
            id: 'AES_CBC_256'
        },{
            name: '3DES-CBC',
            id: 'DES3_CBC',
            tag: 'IPSEC_3DES'
        }
    ];
    $scope.ciphersPhase2 = [
        {
            name: 'AES-CBC-128',
            id: 'AES_CBC_128'
        },{
            name: 'AES-CBC-256',
            id: 'AES_CBC_256'
        },
        {
            name: 'AES-128-GCM-16',
            id: 'AES_GCM_128'
        },{
            name: 'AES-256-GCM-16',
            id: 'AES_GCM_256'
        },{
            name: '3DES-CBC',
            id: 'DES3_CBC',
            tag: 'IPSEC_3DES'
        }
    ];


    $scope.skipIfMissingTag = function (accountTags){
        return function (item){
            if(item.tag && accountTags){
                return (accountTags.indexOf(item.tag) >= 0)
            }
            else{
               return true;
            }
        }
    }


    $scope.hashes = [
        {
            name: 'MD5',
            id: 'MD5'
        },
        {
            name: 'SHA1',
            id: 'SHA1'
        },
        {
            name: 'SHA-256',
            id: 'SHA256'
        }
    ];

    $scope.dhGroups = dhGroupsList;

    $scope.initiatePhase2PerfectForwardSecrecy = function () {
        if($scope.site && $scope.site.ike && !$scope.site.ike.phase2PerfectForwardSecrecy){
            $scope.dhGroupsPhase2 = [
                {
                    name: 'unavailable',
                    id: 'IPSEC_DH_GROUP_NONE'
                }
            ];
            $scope.site.ike.phase2DHGroup = $scope.dhGroupsPhase2[0].id;
        }
        else{
            $scope.dhGroupsPhase2 = dhGroupsList;
            if($scope.site && $scope.site.ike){
                if(!$scope.site.ike.phase2DHGroup || $scope.site.ike.phase2DHGroup == 'IPSEC_DH_GROUP_NONE'){
                    $scope.site.ike.phase2DHGroup = $scope.dhGroupsPhase2[0].id;
                }
            }
        }
    };

    function allowNewSites(){
        store.fetch({
            path: "/allowNewSites?accountId=" + $state.params.accountId,
            success: function(data) {
                $scope.availableSiteLicenses = data;
            }
        });
    }

    // item in main table was changed - need to notify all inner tables
    function updateDataModifiedInInnerTables () {
        $scope.hostsConfig.interfaces = $scope.site.interfaces;
        $scope.hostsdatamodified = new Date().getTime();
        $scope.dnssettingsdatamodified = new Date().getTime();
        $scope.gredatamodified = new Date().getTime();
        $scope.ipsecdatamodified = new Date().getTime();
        $scope.bypassdatamodified = new Date().getTime();
        $scope.portForwardingmodified = new Date().getTime();
        $scope.localrulesdatamodified = new Date().getTime();
        $scope.subnetsdatamodified = new Date().getTime();
        $scope.hostssdatamodified = new Date().getTime();
        $scope.infqosdatamodified = new Date().getTime();
        $scope.allwanqosdatamodified = new Date().getTime();
        $scope.altwanqosdatamodified = new Date().getTime();
        $scope.wan2qosdatamodified = new Date().getTime();
        $scope.groupsDataModified = new Date().getTime();
        $scope.bgpNeighborsDataModified = new Date().getTime();
        for (var i=0; i < 4; i++) {
            $scope.interfacehostsdatamodified['interfacehostsdatamodified' + i] = new Date().getTime();
        }
        if(isSystemLogin){
            $scope.generalpropertiesdatamodified = new Date().getTime();
            $scope.getSitesWithSpecialProperties();
        }
    }

    function setIkev1DefaultValues() {
        if ($scope.site && !$scope.site.ike) {
            $scope.site.ike = {
                routeOption : 'IMPLICIT',
                serviceType : 'Generic',
                phase1EncryptionAlgorithm : 'AES_CBC_256',
                phase1HashAlgorithm : 'SHA1',
                phase1DHGroup : 'DH_2_MODP1024',
                phase2EncryptionAlgorithm : 'AES_CBC_256',
                phase2HashAlgorithm : 'SHA1',
                phase2DHGroup : 'DH_2_MODP1024',
                phase2PerfectForwardSecrecy: false,
                phase1SaLifetime: 86400,
                phase2Lifetime: 3600,
                primaryPrivateIps: {},
                secondaryPrivateIps: {}
            };

        }

        else if($scope.site && $scope.site.ike){
            addPrivateIpsIfNotExist();
        }

    }

        //adding private ips if ike object already exists and private ips don't
        function addPrivateIpsIfNotExist(){
            if(!$scope.site.ike.primaryPrivateIps){
                $scope.site.ike.primaryPrivateIps = {};
                }

             if(!$scope.site.ike.secondaryPrivateIps){
                $scope.site.ike.secondaryPrivateIps = {};
                }
            }

    $scope.changeServiceType = function(){
         if ($scope.site && $scope.site.ike){
            if( $scope.site.ike.serviceType ==  'AWS'){
                $scope.site.ike.phase1EncryptionAlgorithm = 'AES_CBC_128';
                $scope.site.ike.phase1HashAlgorithm = 'SHA1';
                $scope.site.ike.phase1DHGroup = 'DH_15_MODP3072';
                $scope.site.ike.phase2EncryptionAlgorithm = 'AES_CBC_128';
                $scope.site.ike.phase2HashAlgorithm = 'SHA1';
                $scope.site.ike.phase2DHGroup = 'DH_15_MODP3072';
                $scope.site.ike.phase2PerfectForwardSecrecy= true;
                $scope.site.ike.phase1SaLifetime= 28800;
                $scope.site.ike.phase2Lifetime= 3600;
                $scope.site.ike.primaryPrivateIps= {};
                $scope.site.ike.secondaryPrivateIps= {};
                deleteCustomRange();

            }
            else if ($scope.site.ike.serviceType ==  'Generic'){
                $scope.site.ike.phase1EncryptionAlgorithm = 'AES_CBC_256';
                $scope.site.ike.phase1HashAlgorithm  ='SHA1';
                $scope.site.ike.phase1DHGroup = 'DH_2_MODP1024';
                $scope.site.ike.phase2EncryptionAlgorithm = 'AES_CBC_256';
                $scope.site.ike.phase2HashAlgorithm = 'SHA1';
                $scope.site.ike.phase2DHGroup = 'DH_2_MODP1024';
                $scope.site.ike.phase2PerfectForwardSecrecy= false;
                $scope.site.ike.phase1SaLifetime= 86400;
                $scope.site.ike.phase2Lifetime= 3600  ;
                $scope.site.ike.primaryPrivateIps= {};
                $scope.site.ike.secondaryPrivateIps= {};
                deleteCustomRange();
            }
            else if ($scope.site.ike.serviceType ==  'Azure'){
                $scope.site.ike.phase1EncryptionAlgorithm = 'AES_CBC_256';
                $scope.site.ike.phase1HashAlgorithm  ='SHA1';
                $scope.site.ike.phase1DHGroup = 'DH_2_MODP1024';
                $scope.site.ike.phase2EncryptionAlgorithm = 'AES_CBC_256';
                $scope.site.ike.phase2HashAlgorithm = 'SHA1';
                $scope.site.ike.phase2PerfectForwardSecrecy= false;
                $scope.site.ike.phase1SaLifetime= 28800;
                $scope.site.ike.phase2Lifetime= 3600  ;
                $scope.site.ike.primaryPrivateIps= {};
                $scope.site.ike.secondaryPrivateIps= {};
            }
         }
         else{
            deleteCustomRange();
         }
    };

    /**
      * function for deleting the custom range, after changing the type of the site connection
      * or service type in cato initiated ipsec context we would like to delete all custom ranges related data
      *
    **/
    var deleteCustomRange = function (){
        $scope.networkRanges=[];
        $scope.customIps = "";
        if($scope.site){
            if( $scope.site.ike && $scope.site.ike.customRanges){
                delete $scope.site.ike.customRanges;
            }
            if($scope.site.ikeV2 && $scope.site.ikeV2.customRanges){
                delete $scope.site.ikeV2.customRanges;
            }
        }
    };

    /**
      * function returning true if we have set a default value for the given property
    **/
    $scope.ipsecIsDefaultValue = function(){
        return  $scope.site && $scope.site.ike && $scope.site.siteConnType.protoType == "IPSEC_HOST" &&
         ($scope.site.ike.serviceType ==  'AWS' || $scope.site.ike.serviceType ==  'Azure');
    };

    $scope.isAltWanRecoveryConfigured = function() {
        if($scope.site && $scope.site.socketConnectionConfiguration && $scope.site.socketConnectionConfiguration.siteRecoveryPolicy) {
            let siteRecoveryPolicy = $scope.site.socketConnectionConfiguration.siteRecoveryPolicy;
            if(siteRecoveryPolicy.enableRecoveryInternet || siteRecoveryPolicy.enableRecoveryWan) {
                return true;
            }
        }
        return false;
    }

    $scope.isBGPConfigured = function () {
        if($scope.site && $scope.site.bgpNeighbors) {
            let bgpNeighbors = $scope.site.bgpNeighbors;
            if(Array.isArray(bgpNeighbors) && bgpNeighbors.length) {
                return true;
            }
        }
        return false;
    }

    /**
     * function returning true if we have set a default value for the given property and exclude the given
     * parameter
     * @param excludeAws
     * @param excludeAzure
     * @returns {*|{serviceType: string, phase1EncryptionAlgorithm: string, phase1HashAlgorithm: string, phase1DHGroup: string, phase2EncryptionAlgorithm: string, phase2HashAlgorithm: string, phase2DHGroup: string, phase2PerfectForwardSecrecy: boolean, phase1SaLifetime: number, phase2Lifetime: number}|boolean}
     */
    $scope.ipsecIsDefaultValueExclude = function (excludeAws, excludeAzure) {
        if(excludeAws){
            return  $scope.site && $scope.site.ike && $scope.site.siteConnType.protoType == "IPSEC_HOST" &&
                ($scope.site.ike.serviceType ==  'Azure');
        }
        else if(excludeAzure){
            return  $scope.site && $scope.site.ike && $scope.site.siteConnType.protoType == "IPSEC_HOST" &&
                ($scope.site.ike.serviceType ==  'AWS' );
        }
    };

    //adds the deleted general properties from the general properties component to site deleted items list
    $scope.addDeletedGeneralProperties = function (properties) {
    if (properties.length > 0) {
            if (!$scope.site.itemsToDelete) {
                    $scope.site.itemsToDelete = {};
                        }
                $scope.site.itemsToDelete.generalProperties = ($scope.site.itemsToDelete.generalProperties && $scope.site.itemsToDelete.generalProperties.length > 0) ?
                                                                  properties.concat($scope.site.itemsToDelete.generalProperties) : properties;
                                        }
    }

    $scope.isLocationSettingLoaded = function(){
        return ($scope.timezones != undefined && $scope.accountTimezone != undefined && $scope.countries != undefined);
    }

    $scope.tableConfig = {
        hasChanges: $scope.$root.hasChanges,
        noAutoCheckboxSelect: true,
        mode: 'list',
        statusNames:{"DISABLED":"Disabled","ACTIVE":"Active"},
        accountId : $state.params.accountId,
        dataURL : function() {
            return "/getAllSites?accountId=" + ($state.params.accountId? $state.params.accountId : "");
        },
        titleSearch: 'Sites',
        height: $scope.getContentHeight(),
        pageSize: 50,
        afterUpdate: function(){
            if(!$scope.loaded){
                return;
            }
            if($scope.$root){
                $scope.$root.updateScroll('.pane.left .nano');
            }
        },
        searchId: $state.params.id, // in case there is a search value in the URL params, use it to search
        addURL : function(item) {
            return "/showAddSite?inline=showAddSite&parent=sites&accountId=" + $state.params.accountId;
        },
        sortButton: true,
        fields : [
            {"label":"Name","path":"name"},
            {"label":"Description","path":"description"},
            {"label":"Status","path":"status"},
            {"label":"Creation Date","path":"creationDate"},
            {"label":"Last Modified","path":"lastModified"}/*,
             {"label": "", "template": '<img src="/public/images/connectivity.png" style="cursor:' +
             ' pointer;" data-toggle="modal" data-target="#myModal" data-type="site" data-id="{{item.id}}"></img>'}*/
        ],
        type : "Site",
        addAction : function(type) {
            var that = this;
            if(typeof $scope.availableSiteLicenses === 'undefined'){
                $timeout(function(){
                    that.addAction(type);
                }, 100, false);
            }
            else {
                this.addNew(type);
            }
        },
        addNew : function(){
            if($scope.availableSiteLicenses.allowNew){
                $scope.newSite = SiteService.getNewSite();
                $scope.newSite.siteConnType = _.findWhere($scope.siteConnTypes, {value: 'SOCKET_X1500'});
                $scope.newSite.timezone = $scope.accountTimezone;
                $scope.updateNewSiteConnectivityType($scope.newSite);
                $scope.sitesUsage.newSite = [];
                $scope.localIpInSiteCreation = false;
                openAddSiteDlg();
            }
            else if($scope.availableSiteLicenses.isDisable){
                $scope.$root.alert("Account license is Disable, please contact reseller for purchasing new license.");
            }
            else{
                $scope.$root.alert("There are no available licenses for new site, please contact reseller for purchasing new licenses.");
            }
        },
        actions: ["remove"],
        removeConfirmation: function (items) {
            if ($scope.isSystemLogin && $scope.sitesWithSpecialProperties) {
                for (var i = 0;items[i];i++) {
                    if ($scope.sitesWithSpecialProperties.filter(function(sitePropTup){ return sitePropTup === items[i].id}).length > 0) {
                        return 'Please note, at least one selected site has special properties! Are you sure you want to delete it?';
                    }
                }
            }
        },
        specialActions:[
            {
                "func": function(selectedItems) {
                    $scope.disable(selectedItems,"Site");
                    setStatus(selectedItems, true, false);
                },
                "icon":"disable",
                tooltip:"Disable Sites"
            },
            {
                "func":function(selectedItems) {
                    $scope.disable(selectedItems,"Site",true);
                    setStatus(selectedItems, true, true);
                },
                "icon":"enable",
                tooltip:"Enable Sites"
            }
        ],
        processData: function(items) {
            setStatus(items);
            allowNewSites();
        },
        onSelect: function(index) {
            $scope.selectedSiteIndex = index;
            if ($scope && $scope.$root) {
                $scope.$root.closeAllPopups();
            }
            store.fetch({
                path: '/show?type=site&siteId=' + $scope.tableConfig.items[index].id+'&loadExtraData=SOCKET_SETTINGS,HAS_ALTERNATIVE_WAN,BGP_PEER_NETWORK_INFO,HOST_MONITORING_SOURCE_IP,IS_OFF_CLOUD_SUPPORTED,MAC_ADDRESS_OVERRIDE',
                success: function(data){
                    showSite(data);
                    $scope.$digest();
                }
            });
        }
    };


    /**
     * when a socket is unassign we need to reload the site
     * when another virtual socket is added we need to reload
     * this event is dispatched from the socket-unassign.component
     */
    $scope.$on('unassignSocketOrSocketAdditionEvent', function (event, data) {
        // reload current site
        $scope.tableConfig.onSelect($scope.selectedSiteIndex);
    });

    function abortShow(data) {
        var siteIdOfData = data === null ? null : (typeof data === 'number' ? data : data.id);
        return !$scope.loaded || (siteIdOfData !== null && siteIdOfData !== $scope.tableConfig.items[$scope.selectedSiteIndex].id);
    }

    var setIkeRanges = function (){
        $scope.networkRanges=[];
        if($scope.site && $scope.site.ike){
            if($scope.site.ike.customRanges){
                var ranges = "";
                $scope.site.ike.customRanges.forEach(function(range){
                    $scope.networkRanges.push(range);
                    ranges = ranges + "," + range;
                });
                $scope.customIps = ranges.substring(1,ranges.length);
            }
        }
    };

     // set scope param to
     if(isSystemLogin){
        $scope.isSystemLogin = true;

        $scope.tableConfig.specialActions.push({
            "func":function(selectedItems) {
                $scope.configDebugMode(selectedItems,"Site",1);
            },
            "icon":"debugMode",
            tooltip:"Extend Debug Mode"
        });

        $scope.tableConfig.specialActions.push({
            "func":function(selectedItems) {
                $scope.configDebugMode(selectedItems,"Site",0);
            },
            "icon":"debugMode",
            tooltip:"Disable Debug Mode"
        });


     }

    $scope.getSitesWithSpecialProperties = function() {
         store.fetch({
             path: '/getSitesWithGeneralProperties?accountId=' + $state.params.accountId,
             success: function(data) {
                 $scope.sitesWithSpecialProperties = data;
             }
         });
     };

    function setStatus(items, set, setTo){
        if(items && items.length > 0){
            items.forEach(function(item){
                if(set){
                    item.isActive = setTo;
                }
                else {
                    item.isActive = (item.status == 'ACTIVE');
                }
            });
        }
    }

    $scope.hostsConfig = {
        id: "hosts",
        dataURL : function(){
            if(!$scope.site || $scope.site.id < 0){
                return null;
            }
            else {
                return "/subnets?siteId=" + $scope.site.id;
            }
        },
        getData : function() {
            if(!$scope.site || $scope.site.id < 0){
                return {"items":[]};
            }
            return null;
        },
        processData : function(items){
            this.origItems = angular.copy(items);
        },
        showTable: false,
        type : "Subnet",
        actions: [],
        selectedItems:[],
        pageSize:10,
        defer:true,
        specialActions : [
            {'icon':'add','tooltip':'Add','func' :
                function(selectedItems,config) {
                    $scope.hostsConfig.items.push({id:GeneralUtilsService.getRandomId(),"name":"",interfaceName:''});
                    $scope.updateRightScroll();
                }
            },
            {'icon':'trash','tooltip':'Delete','func' :
                function(selectedItems,config) {
                    var deletedHosts = [];
                    selectedItems.forEach(function(item) {
                        for(var i = 0 ; i < $scope.hostsConfig.items.length ; i++){
                            var subnet = $scope.hostsConfig.items[i];
                            if(subnet.id === item.id){
                                $scope.hostsConfig.items.splice(i,1);
                                break;
                            }
                        }
                        if (item.id > 0) {
                            deletedHosts.push(item);
                        }
                    });
                    if (deletedHosts.length > 0) {
                        deletedHosts.forEach(function(host) {
                            var currentInterface;
                            if (host.interface_id && host.interface_id !== "") {
                                currentInterface = $scope.site.interfaces.filter(function(inter) { return inter.interface_id === host.interface_id})[0];
                            } else if ($scope.site.interfaces.length === 1) {
                                currentInterface = $scope.site.interfaces[0];
                            }

                            if (currentInterface) {
                                if (!currentInterface.itemsToDelete) {
                                    currentInterface.itemsToDelete = {};
                                }
                                if (!currentInterface.itemsToDelete.hosts) {
                                    currentInterface.itemsToDelete.hosts = [];
                                }
                                if (currentInterface.itemsToDelete.hosts.indexOf(host) === -1) {
                                    currentInterface.itemsToDelete.hosts.push(host);
                                }
                            }

                        });
                    }
                    config.selectedItems.length = 0;
                    $scope.updateRightScroll();
                }
            }
        ],
        titleSearch: 'Hosts'
    };



    $timeout(function() {
        hostTableFiledSetting();
    }, 0, false);



    $scope.greConfig = {
        id: "greSubnet",
        dataURL : function(){
            return null;
        },
        parseData : function() {
            if ($scope.site) {
                return $scope.site.greRange;
            } else {
                return [];
            }
        },
        fields :  [
            {"label":"Source IP","path":"subnet","template":"<span><input type='text' class='form-control' ng-model='item.subnet' /></span>"}
        ],
        actions : [],
        addAction : function(){
            $scope.site.greRange.push({id:GeneralUtilsService.getRandomId(), name: "gre"});
            $scope.updateRightScroll();
        },
        specialActions : [
            {"func":function(selectedItems) {
                let deletedItems = [];
                selectedItems.forEach(function(item) {
                    for(var i = 0 ; i < $scope.site.greRange.length ; i++){

                        var subnet = $scope.site.greRange[i];
                        if(subnet.id === item.id){
                            $scope.site.greRange.splice(i,1);
                            if (item.id > 0) {
                                deletedItems.push(item);
                            }
                            break;
                        }
                    }
                });
                if (deletedItems.length > 0) {
                $scope.site.itemsToDelete.greRange = ($scope.site.itemsToDelete.greRange && $scope.site.itemsToDelete.greRange.length > 0) ?
                                                         deletedItems.concat($scope.site.itemsToDelete.greRange) :
                                                         deletedItems;
                }
                $scope.updateRightScroll();
            },"icon":"delete",tooltip:"Delete"}
        ],
        selectedItems:[],
        pageSize:10,
        sortList : [],
        noSearch:true
    };

    $scope.ipsecConfig = {
        id: "ipSec",
        dataURL : function(){
            return null;
        },
        parseData : function() {
            if ($scope.site) {
                return $scope.site.ipSec;
            }
                else {
                return [];
            }
        },
        fields :  [
            {"label":"Source IP","path":"subnet","template":"<span><input type='text' class='form-control' ng-model='item.subnet'/></span>"},
            {"label":$sce.trustAsHtml("Upstream Bandwidth <div class='more-info' data-toggle='tooltip' data-placement='bottom' title='If you want Cato Cloud to cap your upstream and downstream bandwidths, enter these values accordingly. Otherwise, enter as defined by your ISP link\'s actual connection speed. If unknown, use the bandwidth according to this site\'s license.'><span class='glyphicon glyphicon-question-sign'></span></div>"), "labelType":"html","path":"upstreamBw","template":"<span><input type='text' class='form-control' ng-model='item.upstreamBw'/></span>"},
            {"label":$sce.trustAsHtml("Downstream Bandwidth <div class='more-info' data-toggle='tooltip' data-placement='bottom' title='If you want Cato Cloud to cap your upstream and downstream bandwidths, enter these values accordingly. Otherwise, enter as defined by your ISP link\'s actual connection speed. If unknown, use the bandwidth according to this site\'s license.'><span class='glyphicon glyphicon-question-sign'></span></div>"), "labelType":"html","path":"downstreamBw","template":"<span><input type='text' class='form-control' ng-model='item.downstreamBw'/></span>"},
        ],
        actions : [],
        addAction : function(){
            if($scope.site.ipSec.length < 2){
                $scope.site.ipSec.push({id:GeneralUtilsService.getRandomId(), name: "ipsec"});
                $scope.updateRightScroll();
            }else{
                if($scope.$root != null && $scope.$root.errors != null){
                    $scope.$root.errors['ipsecTable'] = 'Maximum of two source IPs';
                }
            }
        },
        specialActions : [
            {"func":function(selectedItems) {
                let deletedItems = [];
                selectedItems.forEach(function(item) {
                    for(var i = 0 ; i < $scope.site.ipSec.length ; i++){
                        var subnet = $scope.site.ipSec[i];
                        if(subnet.id === item.id){
                            $scope.site.ipSec.splice(i,1);
                            if (item.id > 0) {
                                deletedItems.push(item);
                            }
                            break;
                        }
                    }
                });
                if (deletedItems.length > 0) {
                $scope.site.itemsToDelete.ipSec = ($scope.site.itemsToDelete.ipSec && $scope.site.itemsToDelete.ipSec.length > 0) ?
                                                       deletedItems.concat($scope.site.itemsToDelete.ipSec) :
                                                       deletedItems;
                }
                $scope.updateRightScroll();
            },"icon":"delete",tooltip:"Delete"}
        ],
        selectedItems:[],
        pageSize:10,
        sortList : [],
        noSearch:true
    };

    function hostTableFiledSetting() {
        $scope.hostsConfig.fields =  [
            {"label":"Name","path":"name","template":"<span><input type='text' class='form-control' ng-model='item.name' /></span>"},
            {"label":"IP","path":"subnet","template":"<span><input type='text' class='form-control' ng-model='item.subnet' /></span>"},
            {"label":"Translated IP","path":"translatedSubnet","template":"<span ng-disabled='true'><input type='text' class='form-control' ng-model='item.translatedSubnet' /></span>"},
            {"label":$sce.trustAsHtml("MAC <div class='more-info' data-toggle='tooltip' data-placement='bottom' title='MAC is an optional field. Populate it if you want to achieve DHCP reservation'><span class='glyphicon glyphicon-question-sign'></span></div>"), "labelType":"html","path":"mac","template":"<span><input type='text' class='form-control' ng-model='item.mac' /></span>"},
            {"label":"Network","path":"interfaceName","template":"<span class='interfaceName' interfaceId='{{item.interface_id}}'>{{item.interfaceName}} <span ng-if='item.range'> \\ {{item.range}}</span></span>"}
        ];
//            $scope.hostsConfig.fields.splice(2, 0, {"label":"Translated IP","path":"translated","template":"<span ng-disabled='true'><input type='text' class='form-control' ng-model='item.translatedSubnet' /></span>"});
    }


    $scope.destBypassConfig = {
        id: 'destBypassAddresses',
        dataURL : function(){
            if(!$scope.site || $scope.site.id < 0){
                return null;
            }
            else {
                return "/destbypassaddress?siteId=" + $scope.site.id;
            }
        },
        getData : function() {
            if(!$scope.site || $scope.site.id < 0){
                return {"items":[]};
            }
            return null;
        },
        processData : function(items){
            this.origItems = angular.copy(items);
        },
        showTable: false,
        titleSearch: "Destination Bypass",
        fields : [
            {"label":"Name","path":"name","template":"<span><input type='text' class='form-control' ng-model='item.name' /></span>"},
            {"label":"Destination IP","path":"ip","template":"<span><input type='text' class='form-control' ng-model='item.ip' placeholder='192.168.128.0/24' /></span>"},
            {"label":"Protocols","path":"protocolsRaw","template":"<span><input type='text' class='form-control' ng-model='item.protocolRaw' placeholder='TCP,UDP,ICMP(optional)' /></span>"}
        ],
        type : "BypassAddress",
        actions: [],
        selectedItems:[],
        pageSize:10,
        defer:true,
        specialActions : [
            {'icon':'add','tooltip':'New','func' :
                function(selectedItems,config) {
                    $scope.destBypassConfig.items.push({id:GeneralUtilsService.getRandomId(),"name":""});
                    $scope.updateRightScroll();
                }
            },
            {'icon':'delete','tooltip':'Delete','func' :
                function(selectedItems,config) {
                    let deletedBypass = [];
                    selectedItems.forEach(function(item) {
                        for(var i = 0 ; i < $scope.destBypassConfig.items.length ; i++){
                            var address = $scope.destBypassConfig.items[i];
                            if(address.id === item.id){
                                $scope.destBypassConfig.items.splice(i,1);
                                if (item.id > 0) {
                                    deletedBypass.push(item);
                                }
                                break;
                            }
                        }
                    });
                    if (deletedBypass.length > 0) {
                        $scope.site.itemsToDelete.destBypassAddresses = ($scope.site.itemsToDelete.destBypassAddresses && $scope.site.itemsToDelete.destBypassAddresses.length > 0) ?
                                                                        deletedBypass.concat($scope.site.itemsToDelete.destBypassAddresses) :
                                                                        deletedBypass;
                    }
                    $scope.updateRightScroll();
                }
            }
        ],
        noSearch:true
    };

    $scope.srcBypassConfig = {
        id: 'sourceBypassAddresses',
        dataURL : function(){
            if(!$scope.site || $scope.site.id < 0){
                return null;
            }
            else {
                return "/srcbypassaddress?siteId=" + $scope.site.id;
            }
        },
        getData : function() {
            if(!$scope.site || $scope.site.id < 0){
                return {"items":[]};
            }
            return null;
        },
        processData : function(items){
            this.origItems = angular.copy(items);
        },
        showTable: false,
        titleSearch: "Source Bypass",
        fields : [
            {"label":"Name","path":"name","template":"<span><input type='text' class='form-control' ng-model='item.name' /></span>"},
            {"label":"Source IP","path":"ip","template":"<span><input type='text' class='form-control' ng-model='item.ip' placeholder='192.168.128.0/24' /></span>"},
            {"label":"Protocols","path":"protocolsRaw","template":"<span><input type='text' class='form-control' ng-model='item.protocolRaw' placeholder='TCP,UDP,ICMP(optional)' /></span>"}
        ],
        type : "BypassAddress",
        actions: [],
        selectedItems:[],
        pageSize:10,
        defer:true,
        specialActions : [
            {'icon':'add','tooltip':'New','func' :
                function(selectedItems,config) {
                    $scope.srcBypassConfig.items.push({id:GeneralUtilsService.getRandomId(),"name":""});
                    $scope.updateRightScroll();
                }
            },
            {'icon':'delete','tooltip':'Delete','func' :
                function(selectedItems,config) {
                    let deletedBypass = [];
                    selectedItems.forEach(function(item) {
                        for(var i = 0 ; i < $scope.srcBypassConfig.items.length ; i++){
                            var address = $scope.srcBypassConfig.items[i];
                            if(address.id === item.id){
                                $scope.srcBypassConfig.items.splice(i,1);
                                if (item.id > 0) {
                                    deletedBypass.push(item);
                                }
                                break;
                            }
                        }
                    });
                    if (deletedBypass.length > 0) {
                        $scope.site.itemsToDelete.sourceBypassAddresses = ($scope.site.itemsToDelete.sourceBypassAddresses && $scope.site.itemsToDelete.sourceBypassAddresses.length > 0) ?
                                                                                deletedBypass.concat($scope.site.itemsToDelete.sourceBypassAddresses) :
                                                                                deletedBypass;
                    }
                    $scope.updateRightScroll();
                }
            }
        ],
        noSearch:true
    };

    $scope.portForwardingConfig = {
        id: 'localPortForwardings',
        dataURL : function(){
            if(!$scope.site || $scope.site.id < 0){
                return null;
            }
            else {
                return "/localPortForwarding?siteId=" + $scope.site.id;
            }
        },
        getData : function() {
            if(!$scope.site || $scope.site.id < 0){
                return {"items":[]};
            }
            return null;
        },
        processData : function(items){
            this.origItems = angular.copy(items);
        },
        showTable: false,
        fields : [
            {"label":"Name","path":"name","template":"<span><input type='text' class='form-control' ng-model='item.name' /></span>"},
            {"label":"External Port","path":"externalPortRange","template":"<span><input type='text' class='form-control' ng-model='item.externalPortRange' placeholder='8000-8002'  ng-change='tableConfig.updateInternalPort(item)' /></span>"},
            {"label":"Internal IP","path":"internalIp","template":"<span><input type='text' class='form-control' ng-model='item.internalIp' /></span>"},
            {"label":"Internal Port","path":"internalPortRange","template":"<span><input type='text' class='form-control' ng-model='item.internalPortRange' placeholder='8000-8002' /></span>"},
            {"label":"Allowed Remote IPs","path":"allowedRemoteIps","template":"<span><input type='text' class='form-control' ng-model='item.allowedRemoteIps' placeholder='68.89.31.226,68.89.31.227(optional)' /></span>"}
        ],
        type : "LocalPortForwarding",
        actions: [],
        selectedItems:[],
        pageSize:10,
        defer:true,
        specialActions : [
            {'icon':'add','tooltip':'New','func' :
                function(selectedItems,config) {
                    $scope.portForwardingConfig.items.push({id:GeneralUtilsService.getRandomId(),"name":""});
                    $scope.updateRightScroll();
                }
            },
            {'icon':'delete','tooltip':'Delete','func' :
                function(selectedItems,config) {
                    let deletedItems = [];
                    selectedItems.forEach(function(item) {
                        for(var i = 0 ; i < $scope.portForwardingConfig.items.length ; i++){
                            var address = $scope.portForwardingConfig.items[i];
                            if(address.id === item.id){
                                $scope.portForwardingConfig.items.splice(i,1);
                                if (item.id > 0) {
                                    deletedItems.push(item);
                                }
                                break;
                            }
                        }
                    });
                    if (deletedItems.length > 0) {
                        $scope.site.itemsToDelete.localPortForwardings = ($scope.site.itemsToDelete.localPortForwardings && $scope.site.itemsToDelete.localPortForwardings.length > 0) ?
                                                                        deletedItems.concat($scope.site.itemsToDelete.localPortForwardings) :
                                                                        deletedItems;
                    }
                    $scope.updateRightScroll();
                }
            }
        ],
        updateInternalPort: function(item){
            // use the external port as internal port
            item.internalPortRange = item.externalPortRange;
        },
        noSearch:true
    };


    var updateUsage = function(siteUsage) {
        if($scope.site && siteUsage){
            $scope.site.siteUsage = $scope.sitesUsage[$scope.site.id].filter(function(usage) { return usage.id == siteUsage; })[0];
        }
    };

    /**
     * usage change - callback for change done in bandwidth selection
     * would like to delete error created by empty bandwidth
     */
    $scope.usageChanged = function () {
        if($scope.$root.errors['licenseError']){
            delete $scope.$root.errors['licenseError'];
        }

    };

    var updateItemsToDelete = function() {
        // had to add AllowIndirectRemovals annotation (cascade problem) - but when this annotation is added delete of subItems are done according to comparing list
        // which mean deleting subItems from other pages, to avoid unwanted removals added a check if item is part of delete map - also if there are no deleted items
        if (!$scope.site.itemsToDelete){
            $scope.site.itemsToDelete = {};
        }
        if (!$scope.site.itemsToDelete.generalProperties){
            $scope.site.itemsToDelete.generalProperties = [];
        }
        if (!$scope.site.itemsToDelete.hosts){
            $scope.site.itemsToDelete.hosts = [];
        }
        if (!$scope.site.itemsToDelete.destBypassAddresses){
            $scope.site.itemsToDelete.destBypassAddresses = [];
        }
        if (!$scope.site.itemsToDelete.sourceBypassAddresses){
            $scope.site.itemsToDelete.sourceBypassAddresses = [];
        }
        if (!$scope.site.itemsToDelete.localPortForwardings){
            $scope.site.itemsToDelete.localPortForwardings = [];
        }
        if (!$scope.site.itemsToDelete.greRange){
            $scope.site.itemsToDelete.greRange = [];
        }
        if (!$scope.site.itemsToDelete.ipSec){
            $scope.site.itemsToDelete.ipSec = [];
        }
        if (!$scope.site.itemsToDelete.ipSec){
            $scope.site.itemsToDelete.ipSec = [];
        }
//        if (!$scope.site.itemsToDelete.interfaces){
//            $scope.site.itemsToDelete.interfaces = [];
//        }

    };

    /**
      * we would like to state to the user if he chose to configure only one egress ip that it isn't recommended by
      * cato
    **/
    function editCatoInitIpsec(){
        $scope.site.secPwShareType = "CATO_INIT_IPSEC";
        if(($scope.site.ike && !$scope.site.ike.secondaryLocalAddress) || ($scope.site.ikeV2 && !$scope.site.ikeV2.secondaryLocalAddress)){
             var message = "You have configured only one IPsec tunnel for this site. Cato strongly recommends setting two tunnels for high availability. Are you sure you want to proceed?";
             $scope.$root.confirm(message,function(){
                doEditSite();
             });
        }
        else{
            doEditSite();
        }
    }


    function handleAllWanQos(transportName,interfaceId,qosTableConfig,origConfig) {

        var modifiedPolicies = [];
        // save policies that changed.
        for (var i = 0 ; i < origConfig.length; i++) {
            if (!angular.equals(origConfig[i], qosTableConfig[i]) || qosTableConfig[i].override) {
                    modifiedPolicies.push(qosTableConfig[i]);
            }
        }

        modifiedPolicies = modifiedPolicies.concat(qosTableConfig.filter(function (item) {return item.override}));
        modifiedPolicies.forEach(function (p) {
                                 p.transport = transportName;
                                 p.interfaceId = interfaceId;
                                 delete p.creationDate;
                                 })

        // save only policies that were overridden in this site
        $scope.site.qosPolicies = $scope.site.qosPolicies.concat(modifiedPolicies);



        // Remove policies that were overridden in origQos but not now.
        for(var i = 0 ; i < origConfig.length ; i++){
            if (origConfig[i].override && !qosTableConfig[i].override){
                if (!$scope.site.itemsToDelete.qosPolicies)
                    $scope.site.itemsToDelete.qosPolicies = [];
                $scope.site.itemsToDelete.qosPolicies.push(origConfig[i]);
            }
        }
    }

//    $scope.showSdwanMutlitunnelModeIfRequired = function(socket) {
//        if ($scope.showSdwanMutlitunnelMode(socket)) {
//            socket.links.forEach(function(linkSettings) {
//                var item = linkSettings.socketLink;
//                if (item.destType =="CATO") {
//                    if (item.role == "wan_1") {
//                        item.naturalOrder = 1;
//                    }
//                    else {
//                        if ($scope.site.socketConnectionConfiguration.multiTunnelMode == 'ACTIVE_PASSIVE') {
//                            item.naturalOrder = 2;
//                        }
//                       else {
//                            item.naturalOrder = 1;
//                        }
//                    }
//                }
//            });
//        }
//    }

    function doEditSite(){
        $scope.site.hosts = $scope.hostsConfig.items;

        /****** update QoS  ****/
        $scope.site.qosPolicies = [];

        var transportName = $scope.site.singleWanBwMgmt ? 'ALL_WAN' : 'SPECIFIC_INTERFACE';
        $scope.site.singleWanQosPolicy = $scope.site.singleWanBwMgmt;
        var origConfig = $scope.origQos;

        if (!$scope.site.singleWanBwMgmt) {
            $scope.catoSocketInterfaces.forEach(function (inf){
                handleAllWanQos(transportName, inf.interface_id, $scope.site.bwManagement[inf.interface_id],$scope.orig.bwManagement[inf.interface_id]);
            });
        }
        else {
            handleAllWanQos(transportName, null, $scope.site.bwManagement[transportName], $scope.orig.bwManagement[transportName]);
        }

        if ($scope.site.hasAlternativeWan) {
            $scope.alternativeWanInterfaces.forEach(function (inf) {
                handleAllWanQos(transportName, inf.interface_id, $scope.site.bwManagement[inf.interface_id],$scope.orig.bwManagement[inf.interface_id]);
            });
        }


        // new site usage for a site with no site usage
        if($scope.site.siteUsage && !$scope.site.siteUsage.id){
            $scope.site.siteUsage = {id:GeneralUtilsService.getRandomId(),"name":"", siteId :  $scope.site.id, region : $scope.site.siteUsage.region};
        }

        if($scope.site.siteUsage){
            $scope.site.siteUsage.siteId = $scope.site.id;
        }

        // Networks
        $scope.site.interfaces.forEach(function(item) {
            if(item.subnets){
                item.subnets.forEach( function(subnet) {
                    subnet.vlanTag = parseInt(subnet.vlanTag);

                    // in case Vlan tag is set to an empty string in the UI we change it to -1 to know that it was not populated and
                    // avoid it being trans to 0 by JSONUtils (which is a valid value)
                    // In the backend -1 will be translated to null so we know it was empty
                    if(!subnet.vlanTag){
                        subnet.vlanTag = -1;
                    }

                    if (subnet.subnetType.value !== 'VLAN' && subnet.subDhcp) {
                        delete subnet.subDhcp;
                    }
                });
            }
        });

        // Bypass
        $scope.site.destBypassAddresses = $scope.destBypassConfig.items;
        $scope.site.sourceBypassAddresses =  $scope.srcBypassConfig.items;
        // Local port forwarding
        $scope.site.localPortForwardings = $scope.portForwardingConfig.items;
        if ($scope.rulesConfig.items && $scope.site.siteConnType.protoType === 'SOCKET_X1500')
            $scope.site.localRoutingRules = $scope.rulesConfig.items;
        if($scope.site.siteConnType.protoType == "IPSEC_HOST"){
            // IKE
            if ($scope.site.ike){
                if(isIkeConfigurationEmpty() && $scope.site.ike.serviceType == 'Generic') {
                    delete $scope.site.ike;
                }
            }
        }
        else{
            delete $scope.site.ike;
        }

        if ($scope.site.siteConnType.protoType !== 'IPSEC_V2') {
            delete $scope.site.ikeV2;
        }

        //update usage
        updateUsage();

        //update itemsToDelete
        updateItemsToDelete();


        // send update request
        var params = {'siteId':$scope.site.id, 'accountId': $state.params.accountId,'save':true, 'loadExtraData':'SOCKET_SETTINGS,HAS_ALTERNATIVE_WAN,BGP_PEER_NETWORK_INFO,HOST_MONITORING_SOURCE_IP,IS_OFF_CLOUD_SUPPORTED,MAC_ADDRESS_OVERRIDE'};
        $scope.site.newSaveMethod = true;

        // remove the state raw for a country with no states
        if($scope.countries[$scope.site.countryRaw] && !$scope.countries[$scope.site.countryRaw].filename){
            $scope.site.stateRaw = "";
        }

        if ($scope.site.isGeneralPropertiesUpdated){
            $scope.site.generalProperties = $scope.generalPropertiesToSave;
        }

        /*
            We remember if this field is initially null, and if there were no changes to it, we take care to send null value back.
         */
        if ($scope?.site?.socketConnectionConfiguration?.isMacAuthOverride === false) {
            if ($scope.site?.socketConnectionConfiguration?.macAddressAuthenticationEnabled === false && $scope.macAddressAuthenticationEnabledInitialyUndefined) {
                delete $scope.site?.socketConnectionConfiguration?.macAddressAuthenticationEnabled
            }
        }
        delete $scope.macAddressAuthenticationEnabledInitialyUndefined;

        var siteToSave = angular.copy($scope.site);

        SiteService.fixSiteSocketData(siteToSave.socketConnectionConfiguration);

        $scope.loading = true;

        //removing pw field from site we are going to save for non-system user trying to add pw for socket site
        if (!isSystemLogin && siteToSave.pw != null && siteToSave.siteConnType.socketModelTypeConfiguration){
            delete siteToSave.pw;
        }

        //update failover config
        if($scope.failoverConfigChanged) {
            siteToSave.failoverConfiguration = $scope.failoverConfig;
        } else {
            delete siteToSave.failoverConfiguration
        }

        store.save({
            path: "/edit",
            data: siteToSave,
            dataObj: 'json',
            queryParams: params,
            preSave: function (data) {
                if(data){
                    if(data.ikeV2){
                        /*
                        * if there is a secondary local address which is not defined -
                        * was temper with an allocated ip to mark it as a deleted one
                        * the existing allocated ip is required in order to provide a
                        * valid entity to the baseModel since it checks if account is a property
                        * on the model which could fail the saving
                        */
                        if(data.ikeV2.primaryLocalAddress && data.ikeV2.secondaryLocalAddress && !data.ikeV2.secondaryLocalAddress.id){
                            data.ikeV2.secondaryLocalAddress = angular.copy(data.ikeV2.primaryLocalAddress);
                            data.ikeV2.secondaryLocalAddress.ip = '';
                            data.ikeV2.secondaryLocalAddress.popId = -1;
                        }
                    }
                    if (data.ipSecMode != "MAIN") {
                        data.ipSec = [];
                    }
                }
            },
            success: function(data) {
                $scope.loading = false;
                $scope.$root.handleServerResponse(data,"site", "Site saved successfully");
                if(data.status !== "ERROR"){
                    showSite(data.model, true);
                }
                else{
                    data.notifications.forEach(function(notification){
                        if(notification.field == ".pw"){
                               $scope.showEditPW = true;
                               if($scope.site && $scope.site.siteConnType.protoType == 'IPSEC_V2'){
                                   $scope.ikeV2Properties.showEditPW = true;
                               }
                        }
                        if(notification.field == ".secPw"){
                            $scope.showEditSecPW = true;
                            if($scope.site && $scope.site.siteConnType.protoType == 'IPSEC_V2'){
                                $scope.ikeV2Properties.showEditSecPW = true;
                            }
                        }
                    });
                }
            }
        });
    }

    $scope.socketInterfaceNameChangedListener = function(socketConnectionConfiguration) {
        if($scope.site.interfaces && $scope.site.interfaces.find) {
            let relevantInterface = $scope.site.interfaces.find((socketInterface) => {
                return socketInterface.interface_id == socketConnectionConfiguration.interface_id;
            });
            if(relevantInterface) {
                relevantInterface.name = socketConnectionConfiguration.name;
            }
        }
    }

    function isIkeConfigurationEmpty(){
        return !$scope.site.ike.primaryLocalAddress && !$scope.site.ike.destinationIpPrimary &&
               !$scope.site.ike.secondaryLocalAddress && !$scope.site.ike.destinationIpSecondary &&
               !$scope.site.ike.primaryPrivateIps.sitePrivateIp && !$scope.site.ike.primaryPrivateIps.catoPrivateIp &&
               !$scope.site.ike.secondaryPrivateIps.sitePrivateIp && !$scope.site.ike.secondaryPrivateIps.catoPrivateIp &&
               !$scope.site.ike.phase1DHGroup && !$scope.site.ike.phase2DHGroup
    }

    function copyLinkSettings(linkToCopy, targetLink) {
        targetLink.destType = linkToCopy.destType;
        targetLink.upstreamBandwidth = linkToCopy.upstreamBandwidth;
        targetLink.downstreamBandwidth = linkToCopy.downstreamBandwidth;
        targetLink.gatewayIP = linkToCopy.gatewayIP;
        targetLink.interfaceIP = linkToCopy.interfaceIP;
        targetLink.networkMask = linkToCopy.networkMask;
    }

    /**
     * filling the zones according to the sites this is usage when account is in commercial
     * mode when we want to display only available zones - this is relevant only for non trial
     * account
     */
    function fillZonesFromSiteUsage() {
        if($scope.currentLifeCycleStatus && $scope.currentLifeCycleStatus== LifeCycleTypes.commercial){
            if ($scope.site && $scope.sitesUsage && $scope.sitesUsage[$scope.site.id] && origSiteUsages) {
                $scope.zones = [];
                origSiteUsages.forEach(function (usage) {
                    if($scope.zones.indexOf(usage.region)==-1){
                        $scope.zones.push(usage.region);
                    }
                });
            }
        }
    }

    var LifeCycleTypes = {
        commercial: 'Commercial',
        trial: 'Trial',
        lock: 'Lock',
        disable: 'Disable'
    };

    /**
     * initiate zones for sites, zones are used to set which pop will
     * the site will connect to
     */
    var initZones = function () {
        if (!$scope.zones && $scope.currentLifeCycleStatus == undefined) {
            if($scope.currentLifeCycleStatus==LifeCycleTypes.commercial){
                fillZonesFromSiteUsage();
            }
            else{
                ZoneService.getRegions(function (zones) {
                    $scope.zones = zones;
                });
            }
        }
    };

    var siteChanged = false;

    function setIKEV2DefaultValues() {
        if (!$scope.site.ikeV2) {
            $scope.site.ikeV2 = {routeOption : 'SPECIFIC_RANGES'};
        }
        if (!$scope.site.ikeV2.initEncryption) {
            $scope.site.ikeV2.initEncryption = 'AUTOMATIC'
        }
        if ($scope.site.ikeV2.shouldCatoInitiateConnection == null) {
            $scope.site.ikeV2.shouldCatoInitiateConnection = true;
        }
        if (!$scope.site.ikeV2.initPseudoRandomFunctionAlgorithm) {
            $scope.site.ikeV2.initPseudoRandomFunctionAlgorithm = 'AUTOMATIC_PRF';
        }
        if (!$scope.site.ikeV2.initIntegrityAlgorithm) {
            $scope.site.ikeV2.initIntegrityAlgorithm = 'AUTOMATIC_INTEGRITY';
        }
        if (!$scope.site.ikeV2.initDhGroups) {
            $scope.site.ikeV2.initDhGroups = 'GROUP_15_MODP3072';
        }

        if (!$scope.site.ikeV2.initEncryption) {
            $scope.site.ikeV2.initEncryption = 'AUTOMATIC';
        }
        if(!$scope.site.ikeV2.authEncryption){
            $scope.site.ikeV2.authEncryption = 'AUTOMATIC';
        }

        if (!$scope.site.ikeV2.authIntegrityAlgorithm) {
            $scope.site.ikeV2.authIntegrityAlgorithm = 'AUTOMATIC_INTEGRITY';
        }
        if (!$scope.site.ikeV2.authDhGroups) {
            $scope.site.ikeV2.authDhGroups = 'GROUP_0_NONE';
        }
        if(!$scope.site.secPwShareType){
            $scope.site.secPwShareType = 'CATO_INIT_IPSEC';
        }
        if(!$scope.site.ikeV2.primaryPrivateIps){
            $scope.site.ikeV2.primaryPrivateIps = {};
            }
        if(!$scope.site.ikeV2.secondaryPrivateIps){
            $scope.site.ikeV2.secondaryPrivateIps = {};
            }
    }

    /**
     * since we populate the vlan tag with -1 to avoid conversion to 0 by the json utils
     * we need to convert -1 top "" at the client as well this postLoad on the site is doing
     * just that
     * @param data
     * @returns {*}
     */

    function sitePostLoad(data) {
        if(data && data.interfaces){
            data.interfaces.forEach(function (singleInterface) {
                if(singleInterface && singleInterface.subnets){
                    singleInterface.subnets.forEach(function (subnet) {
                        if(subnet && subnet.vlanTag == -1){
                            subnet.vlanTag = '';
                        }
                    })
                }
            });
        }
        if (data && data.selectedLocations) {
            data.selectedLocations.sort((a,b) => (a.priority > b.priority) ? 1 : ((b.priority > a.priority) ? -1 : 0))
        }
        return data;
    }

    // listener fo changes in the general properties, properties field sent to this function is the diff after equal check
    $scope.generalPropertiesChanged = function (properties, isGeneralPropertiesUpdated) {
        if (isGeneralPropertiesUpdated){
            $scope.generalPropertiesToSave = properties;
        }
        $scope.site.isGeneralPropertiesUpdated = isGeneralPropertiesUpdated;
    }

    function showSite(data, updateTableItem) {
        if (abortShow(data)) {return;}
        sitePostLoad(data);
        setSDWAN(data);
        updateCurrentLifecycleStatus(data);

        // init preferred pop locations
        if (!data.selectedLocations)
            data.selectedLocations = [];

        if (abortShow(data)) {return;}

        if (data.timezone == null)
            data.timezone = $scope.accountTimezone;

        //will be added by the general-property component itself
        delete data.generalProperties;
        data.isGeneralPropertiesUpdated = false;


        $scope.site = data;

        if ($scope.$root.tags.indexOf('ALT_WAN_RECOVERY') > -1) {
            // creating defaults for siteRecoveryPolicy
            if ($scope.isSiteSupportSiteRecoveryPolicy() && $scope.isSocketTypeSupportSiteRecoveryPolicy() && data.hasAlternativeWan &&
                data.socketConnectionConfiguration && data.socketConnectionConfiguration.siteRecoveryPolicy == null){
                data.socketConnectionConfiguration.siteRecoveryPolicy = {};
                data.socketConnectionConfiguration.siteRecoveryPolicy.enableRecoveryWan = false;
                data.socketConnectionConfiguration.siteRecoveryPolicy.enableRecoveryInternet = false;
            }
        }


        initEgressOptions();
        /*
            There is difference between null and false value for this field in entity editor.
            And looks like this intentionally nullable field in the model.
            We remember if this field is initially null, and if there were no changes to it, we take care to send null value back.
         */
        if (typeof $scope.site?.socketConnectionConfiguration?.macAddressAuthenticationEnabled === 'undefined') {
            $scope.macAddressAuthenticationEnabledInitialyUndefined = true;
        }

        if ($scope.$root.tags.indexOf('QOS_ALERTS') > -1) {
            FailoverConfigurationService.getConfiguration($scope.accountId, $scope.site.id, (data) => {
                $scope.failoverConfig = data;
                $scope.failoverConfig.accountId = $scope.accountId;
            });
        }

        if($scope.site.siteConnType.protoType == 'IPSEC_V2'){
            if(!$scope.site.ikeV2){
                $scope.site.ikeV2 = {};
            }
            $scope.ikeV2Properties = {
                site: $scope.site,
                showEditPW : false,
                showEditSecPW : false,
                reload: true
            };
        }

        //initialize private ips object of ipsec if wasn't created before
        if($scope.site && $scope.site.siteConnType.protoType === 'IPSEC_CLIENT' &&  !$scope.site.ipsecPrivateIps){
            $scope.site.ipsecPrivateIps = {};
        }

        initZones();
        initiateConfigureEgressSaveEnabled();
        updateSelectedSecondaryEgress();
        setAllowGreTunnel();
        setIkeRanges();
        $scope.initiatePhase2PerfectForwardSecrecy();

        setSingleWanQosPolicy();

        if($scope.site.siteConnType.protoType == "IPSEC_HOST" || $scope.site.siteConnType.protoType == "IPSEC_V2"){
            delete $scope.ikeRouteConfiguration.ikeConfiguration;
            if($scope.ikeRouteConfiguration.reload){
                $scope.ikeRouteConfiguration.reload();
            }
            $scope.ikeTestConnectionConfiguration.accountId =  $state.params.accountId;
            $scope.ikeTestConnectionConfiguration.siteId = $scope.site.id;
            $scope.ikeTestConnectionConfiguration.reload = true;
            // if site is cato initiated IPSec we load default values(only if needed)
            if($scope.site.siteConnType.protoType == "IPSEC_HOST"){
                setIkev1DefaultValues(); // Make sure it's before the copy of the orig
                $scope.ikeTestConnectionConfiguration.ikeConfiguration = $scope.site.ike;
                $scope.ikeRouteConfiguration.ikeConfiguration = $scope.site.ike;
                if(!$scope.ikeRouteConfiguration.ikeConfiguration.customRanges){
                    $scope.ikeRouteConfiguration.ikeConfiguration.customRanges = [];
                }
                if(!$scope.site.ike.primaryIkeBandwidth){
                    $scope.site.ike.primaryIkeBandwidth = {};
                }
                if(!$scope.site.ike.secondaryIkeBandwidth){
                    $scope.site.ike.secondaryIkeBandwidth = {};
                }
            }
            if($scope.site.siteConnType.protoType == "IPSEC_V2"){
                setIKEV2DefaultValues();
                $scope.ikeRouteConfiguration.ikeConfiguration = $scope.site.ikeV2;
                $scope.ikeTestConnectionConfiguration.ikeConfiguration = $scope.site.ikeV2;
                if(!$scope.site.ikeV2.primaryIkeBandwidth){
                    $scope.site.ikeV2.primaryIkeBandwidth = {};
                }
                if(!$scope.site.ikeV2.secondaryIkeBandwidth){
                    $scope.site.ikeV2.secondaryIkeBandwidth = {};
                }
            }
            else{
                delete $scope.site.ikeV2;
            }
        }

        if(!$scope.ikeTestConnectionConfiguration.hasChanges){
            $scope.ikeTestConnectionConfiguration.hasChanges = $scope.$root.hasChanges;
        }

        if($scope.orig && !updateTableItem){
            siteChanged = true;
        }
        if ($scope.site.localRoutingRules) {
            $scope.site.localRoutingRules.forEach(function(rule) {rule.status='saved'});
        }
        $scope.updateConnectionType($scope.site);
        $scope.setMacAuthOverride();
        $scope.setRightPanelHeight();
        $scope.updateRightScroll();
        initBWManagementData();
        initDummyPreferredLocationIfNeeded();
        offCloudStaticIpSupportedInNic();
        updateManagementIpsAfterSaveForAwsHaSites($scope.site);
        /*
         * Notice : any changes on the site below this line
         * will cause the save button to be enabled since has changes
         * compars between the orig and the site
         */
        $scope.orig = angular.copy($scope.site);



        updateDataModifiedInInnerTables();
        $scope.showEditPW = false;
        $scope.showEditSecPW = false;
        $scope.$root.clearErrors();
        if($scope.site.countryRaw){
            $scope.getStatesAndLicense($scope.countries[$scope.site.countryRaw], $scope.site);
        }

        $scope.ikeRouteConfiguration.siteId =  $scope.site.id;


        if (updateTableItem) {
            var i;
            for (i = 0;$scope.tableConfig.items[i];i++) {
                if ($scope.tableConfig.items[i].id === data.id) {
                    break;
                }
            }

            $scope.tableConfig.items[i] = data;
        }

        $scope.$digest();

        $scope.$broadcast('reset-properties');
        $scope.$broadcast('modelReloadedEvent', {model: $scope.site});
        $scope.failoverConfigChanged = false;
        $scope.failoverConfig = data.failoverConfiguration;
        $scope.componentHasChanges = [];
        if($scope.getUsedPrecedences) {
            $scope.usedPrecedences = $scope.getUsedPrecedences(true);
            calculateHighAvailabilitySiteSettings();
        }
    }

    let offCloudStaticIpSupportedInNic = () => {
        if ($scope?.site?.socketConnectionConfiguration?.socketsSettings?.primary?.supportedFeatures?.includes("OFF_CLOUD_STATIC_IP_FOR_CATO_NIC")){
            $scope.site.socketConnectionConfiguration.socketsSettings.primary.isOffCloudStaticIpSupportedInNic = true;
        }
    };

    function initDummyPreferredLocationIfNeeded() {
        const autoId = -1;
        const noneId = -2;

        if (!$scope.site.selectedLocations || $scope.site.selectedLocations.length === 0) {
            $scope.site.selectedLocations = [];
            $scope.site.selectedLocations.push({locationId: autoId, priority: 0, name: "Automatic (default)"});
        }
        if ($scope.site.selectedLocations.length === 1) {
            $scope.site.selectedLocations.push({locationId: autoId, priority: 1, name: "Automatic (default)"});
        }
    }

    $scope.editSite = function(){
        clearIPSecMode();
        // in case we use cato initiated ipsec connection we set the second share type
        if($scope.site.siteConnType.protoType == "IPSEC_HOST" || $scope.site.siteConnType.protoType == "IPSEC_V2"){
            editCatoInitIpsec();
        }
        else{
            doEditSite();
        }

    };

    /**
     * hence the site is not IPSEC_CLIENT there is no need to have ipSecMode
     * on it thus deleting
     */
    var clearIPSecMode = function () {
        if ($scope.site && $scope.site.siteConnType.protoType != 'IPSEC_CLIENT') {
            delete $scope.site.ipSecMode;

        }
    };

    $scope.addSite = function(){
        if($scope.newSite.siteConnType.requirePassword){
            if (!$scope.validPasswordConfirm) {
                return;
            }
        }

        var params = {'accountId': $state.params.accountId,'type':'site','save':true};

        if ($scope.newSite.siteConnType.socketModelTypeConfiguration) {

            var defaultInterface = $scope.newSite.socketConnectionConfiguration.socketInterfaces.filter(function(inter) { return inter.role === 'wan_1'; })[0];

            defaultInterface.downstreamBandwidth = $scope.newSite.wan1DownstreamBandwidth;
            defaultInterface.upstreamBandwidth = $scope.newSite.wan1UpstreamBandwidth;

            if ($scope.enableSecondaryWAN && $scope.enableSecondaryWAN.value == true){
                var defaultInterface = $scope.newSite.socketConnectionConfiguration.socketInterfaces.filter(function(inter) { return inter.role === 'wan_2'; })[0];
                defaultInterface.downstreamBandwidth = $scope.newSite.wan2DownstreamBandwidth;
                defaultInterface.upstreamBandwidth = $scope.newSite.wan2UpstreamBandwidth;
            }

            $scope.newSite.socketConnectionConfiguration.preferHigherNaturalOrder = true;
            $scope.newSite.socketConnectionConfiguration.fallbackPrecedenceDuration = {
                length: 10,
                unit: 'MINUTES'
            };
            $scope.newSite.socketConnectionConfiguration.acceptableNaturalOrder = 1;
            $scope.newSite.socketConnectionConfiguration.fallbackPrecedenceDurationFactor = 2;
        }

        var siteToAdd = angular.copy($scope.newSite);
        SiteService.fixSiteSocketData(siteToAdd.socketConnectionConfiguration);

        $scope.loadingSaveNewSite = true;
        store.save({
            path: "/add",
            data: siteToAdd,
            dataObj: 'json',
            queryParams: params,
            success: function(data) {
                $scope.loadingSaveNewSite = false;
                $scope.$root.handleServerResponse(data,"newSite", "Site added successfully");
                if (data.status !== "ERROR"){
                    $scope.enableSecondaryWAN = {value :false};
                    $scope.tableConfig.selectedId = data.model.id;
                    $scope.datamodified = new Date().getTime();
                    $scope.$root.closePopup('addSiteDlg');
                }
            }
        });
    };

    $scope.$watch('site.countryRaw', function(newVal, oldVal) {
        if (newVal && !angular.equals($scope.site.countryRaw, $scope.orig.countryRaw)) {
            $scope.site.stateRaw = "";
        }
    })

    //gets list of states by country and license by site and country
    $scope.getStatesAndLicense = function(country, site) {
        if(country && country.filename){
            //add all states in a country to states array by country code
            if (!$scope.states[country.code]) {
                store.fetch({
                    path: "/states?country=" + country.filename,
                    success: function(data) {
                        $scope.states[country.code] = data;
                    }
                });
            }
        }else if (country && country.timezone != null){
            // updtae timezone only if empty or country have changed
            if(!site.timezone || !$scope.orig || $scope.orig.countryRaw !== site.countryRaw ){
                site.timezone = country.timezone[0];
            }
            if (!(site.id < 0) && $scope.orig.countryRaw == site.countryRaw){
                site.stateRaw = $scope.orig.stateRaw;
            }
        }

        $scope.getAvailableLicense(country, site);
    };

    // calculate timezone base on state
    $scope.calcTimezone = function(site){
        if (site.stateRaw != null && $scope.states[site.countryRaw] && $scope.states[site.countryRaw][site.stateRaw].timezone != null)
            site.timezone = $scope.states[site.countryRaw][site.stateRaw].timezone;
    }
    /**
     * after loading all licenses and loading the site we apply the license on the site
     * this way enforce that the site user will see the correct license
     * @param site
     */
    function applySiteUsage() {
        if ($scope.site && $scope.site.siteUsage && $scope.sitesUsage[$scope.site.id]) {
            $scope.sitesUsage[$scope.site.id].forEach(function (siteUsage) {
                if ($scope.site.siteUsage.id==siteUsage.id) {
                    /*
                     * setting the site usage and the orig in order to fill the bandwidth
                     * and the orig to prevent has change to return true
                    */
                    $scope.site.siteUsage = siteUsage;
                    // we copy since we don't want changes to be auto applied
                    $scope.orig.siteUsage = angular.copy(siteUsage);
                    fillZonesFromSiteUsage();
                }
            })
        }
    }

    $scope.getAvailableLicense = function(country, site) {
        var siteParam = (site.id > 0) ? "&siteId=" + site.id : "";
        if(country){
            store.fetch({
                path: "/planAvailableSiteUsage?accountId="+$state.params.accountId+"&zone=" + country.zone + "&path=.siteUsage" + siteParam,
                success: function(data) {
                    if(abortShow(site.id > 0 ? site.id : null)){return;}

                    if (data.items){
                        origSiteUsages = angular.copy(data.items);

                        $scope.$root.handleServerResponse(data,null, null, null, true);

                        let itemsToUse = data.items;
                        if(site?.siteUsage?.region) {
                            itemsToUse = itemsToUse.filter(usage => usage.region == site.siteUsage.region || usage.id == site.siteUsage.id)
                        }

                        if(site.id > 0){
                            $scope.sitesUsage[site.id] = itemsToUse;
                        }else{
                            $scope.sitesUsage.newSite = itemsToUse;
                        }
                    }else{
                        if (site.id > 0){
                            $scope.$root.handleServerResponse(data,"site", null, null, true);
                            $scope.sitesUsage[site.id] = [];
                        }else{
                            $scope.$root.handleServerResponse(data,"newSite", null, null, true);
                            $scope.sitesUsage.newSite = [];
                        }
                    }
                    applySiteUsage();
                    $scope.$digest();
                }
            });
        }
    };


    function getOrigSiteUsageById(id) {
        var res = null;
        origSiteUsages.forEach(function (origUsage) {
            if(origUsage.id == id)
                res =  angular.copy(origUsage);
        });
        return res;
    }


    /**
     * upon change on the site interfaces we will deduce if we want to display all route options
     * Logic:
     * A site with a single (native) range should NOT have the option to choose "Explicit"
     * A site which had multiple ranges (native & direct), and chose "Explicit" and then deleted additional ranges
     * and is now with a single (native) range, shall be automatically switched to "Implicit"
     */
    $scope.$watch("site.interfaces", function(newVal, oldVal){
        if($scope.site && $scope.ikeRouteConfiguration && $scope.ikeRouteConfiguration.ikeConfiguration
            && newVal && !angular.equals(newVal,oldVal)){
            $scope.ikeRouteConfiguration.allRouteOptions = false;
            if($scope.site.interfaces.length >1){
                $scope.ikeRouteConfiguration.allRouteOptions = true;
            }
            else{
                $scope.site.interfaces.forEach(function (siteInterface) {
                    if(siteInterface.subnets && siteInterface.subnets.length>0){
                        $scope.ikeRouteConfiguration.allRouteOptions = true;
                    }
                });
            }
        }
    });

    $scope.$watch('site.ike.serviceType', function (newVal, oldVal) {
        $scope.ikeRouteConfiguration.onlySpecific = false;
        if(newVal && newVal == 'Azure') {
            $scope.ikeRouteConfiguration.onlySpecific = true;
        } else if(newVal != 'Azure') {
            $scope.ikeRouteConfiguration.onlySpecific = false;
        }
    });


    /**
     * handling changes in the site usage for filtering the lists
     * if we change the region we would like to see filtered license
     * if we change the license we would like to load the region and bandwidth of
     * this license
     */
    $scope.$watch("site.siteUsage.region", function(newVal, oldVal){

        /**
         * populate the options of the site usage,
         * we display only options relevent to current selected site usage\ zone
         */
        function populateSiteUsageOptions() {
            $scope.sitesUsage[$scope.site.id] = [];
            if(origSiteUsages){
                origSiteUsages.forEach(function (usage) {
                    if (usage.region == newVal)
                        $scope.sitesUsage[$scope.site.id].push(angular.copy(usage));
                });
            }
        }


        /**
         * clear the current site usage populate the region with current newVal
         * and create error on the bandwidth since we just populated the region
         */
        function clearCurrentSiteUsage() {
            if(!siteChanged){
                $scope.site.siteUsage = {};
                $scope.site.siteUsage.region = newVal;
                $scope.$root.errors['licenseError'] = noBandwidthOnLicenseMessage;
            }
            else{
                siteChanged = false;
            }
        }

        if($scope.currentLifeCycleStatus== LifeCycleTypes.commercial){
            if(newVal != oldVal && $scope.site.siteUsage){
                // change site usage
                if($scope.site.siteUsage.id  && $scope.site.siteUsage.id != $scope.orig.siteUsage.id){
                    if(!angular.equals(getOrigSiteUsageById($scope.site.siteUsage.id),$scope.site.siteUsage)){
                        if(!angular.equals(getOrigSiteUsageById($scope.site.siteUsage.id),$scope.site.siteUsage)){
                            clearCurrentSiteUsage();
                            populateSiteUsageOptions();
                        }
                    }
                }
                else{
                    // no id meaning multiple change of region
                    if($scope.site.siteUsage.region != $scope.orig.siteUsage.region || $scope.site.siteUsage.id){
                        clearCurrentSiteUsage();
                    }
                    populateSiteUsageOptions();
                }
            }
        }
    });


    store.fetch({
        method: 'POST',
        path: "/domains",
        queryParams: {
            accountId: $state.params.accountId
        },
        success: function(data) {
            if (data) {
                $scope.domains = [{id:-1,name:''}].concat(data.items);
            } else {
                $scope.domains = [{id:-1,name:''}];
            }

        }
    });

    store.fetch({
        path: "/getAccountTimezone?accountId=" + $state.params.accountId,
        success: function(data) {
            $scope.accountTimezone = data;
        }
    });

    store.fetch({
        path: "/countries",
        success: function(data) {
            $scope.countries = data;
        }
    });

    // test IKE configuration for specific site
    $scope.testIkeConnection = function() {

        if (!$scope.site || !$scope.site.id) {
            return;
        }
        if (!$scope.ikeTest) {
            $scope.ikeTest = {};
        }
        $scope.ikeTest[$scope.site.id] = "Going to test connection...";

        // build URL
        var url = "/testSiteIkeConnection?accountId=" + $state.params.accountId + "&siteId=" + $scope.site.id;
        // Send request
        store.fetch({
            method : 'GET',
            url : url ,
            success: function(data) {
                $scope.ikeTest[$scope.site.id] = data;
            },
            error: function() {
                $scope.ikeTest[$scope.site.id] = "Failed to test connection";
            }
        });

    };

    function setSDWAN(data){
        data.hasAlternativeWan = data.socketConnectionConfiguration && data.socketConnectionConfiguration.socketInterfaces.filter(function(item) {
            return ((item.destType.value === 'ALTERNATIVE') || (item.destType.value === 'LAYER_2_WAN'))
        }).length > 0 ;

        $scope.possibleTransports = {
            "WAN": "Cato Cloud",
        };

        if (data.hasAlternativeWan) {
            $scope.possibleTransports["ALTERNATIVE_WAN"] = "Alternative WAN";
            $scope.possibleTransports["AUTOMATIC"] = "Automatic";
        } else {
            $scope.possibleTransports["ALTERNATIVE_WAN"] = "Alternative WAN " + NA_MESSAGE;
            $scope.possibleTransports["AUTOMATIC"] = "Automatic " + NA_MESSAGE;
        }

        if (data.siteConnType.socketModelTypeConfiguration) {

            var order = 0;
            //connect each network interface to relevant socket interface
            data.interfaces.forEach(function(inter) {
                data.socketConnectionConfiguration.socketInterfaces.forEach(function(socketInterface) {
                    if (inter.interface_id == socketInterface.interface_id) {
                        inter["socketInterface"] = socketInterface;
                        inter["order"] = socketInterface.order;
                    }
                });
                if (!inter["order"]){
                    inter["order"] = order;
                }
                if(!inter["socketInterface"]){
                    data.socketConnectionConfiguration.socketInterfaces.forEach(function(socketInterface) {
                        if (inter.order == socketInterface.order) {
                            inter["socketInterface"] = socketInterface;
                            inter["interface_id"] = socketInterface.interface_id;
                        }
                    });
                }
                order++;
            });
        }

        /**
         * Generating list of precedences for fail-over dropdown from all set up links that destType is Cato.
         * The list will contain all the selected precedences except for the max.
         */
        $scope.getUsedPrecedences =  function(doNotDelete) {
            if (!$scope.site.socketConnectionConfiguration || !$scope.site.socketConnectionConfiguration.socketsSettings.primary)
                return;

            var selectedPrecedence = $scope.site.socketConnectionConfiguration.acceptableNaturalOrder || 1;
            var maxSelectedPrecedence = 0;
            var precedencesList = {
                1: '1 (Primary)'
            };

            // for on all CATO links to add all possible fail-over precedences
            for(var index = 0; index < $scope.site.socketConnectionConfiguration.socketsSettings.primary.links.length; index++){
                var socketLink = $scope.site.socketConnectionConfiguration.socketsSettings.primary.links[index];
                if (socketLink.destType.value == "CATO"){
                    var precedence = socketLink.naturalOrder;
                    maxSelectedPrecedence = Math.max(maxSelectedPrecedence, precedence);
                    if (precedencesList[precedence] == undefined){
                        precedencesList[precedence] = precedence + ' (Secondary)';
                    }
                }
            }

            // removing max since cant fail-over to it
            if (!doNotDelete && maxSelectedPrecedence > 1) {
                delete precedencesList[maxSelectedPrecedence];
            }

            // add selected precedence if not exits in list
            if (precedencesList[selectedPrecedence] == undefined && selectedPrecedence != 1){
                precedencesList[selectedPrecedence] = selectedPrecedence + ' (Secondary)';
            }
            return precedencesList;
        };
    }

    $scope.swapSocketInterfaces = function (firstInterface, secondInterface) {
        $scope.site.interfaces.forEach(inter => {
            if (inter.interface_id === firstInterface.interface_id) {
                inter.interface_id = secondInterface.interface_id;
            } else if (inter.interface_id === secondInterface.interface_id) {
                inter.interface_id = firstInterface.interface_id;
            }
        });
    }

    $scope.precedenceChangeListener = function(link) {
        $scope.usedPrecedences = $scope.getUsedPrecedences(true);
        calculateHighAvailabilitySiteSettings();
    }

    function calculateHighAvailabilitySiteSettings() {
        $scope.isActiveActive = false;
        $scope.isActivePassive = false;
        if (!$scope.site.socketConnectionConfiguration || !$scope.site.socketConnectionConfiguration.socketsSettings.primary)
            return;

        var precedencesList = {
            1: 0,
            2: 0,
            3: 0,
        };

        var amountOfCatoLinks = 0; //amount of configure
        var changedPrecedences = 0;

        // for on all CATO links to add all possible fail-over precedences
        for(var index = 0; index < $scope.site.socketConnectionConfiguration.socketsSettings.primary.links.length; index++){
            var socketLink = $scope.site.socketConnectionConfiguration.socketsSettings.primary.links[index];
            if (socketLink.destType.value == "CATO"){
               amountOfCatoLinks++;
               if(precedencesList[socketLink.naturalOrder] == 0){
                  changedPrecedences++;
               }
               precedencesList[socketLink.naturalOrder]++;
               if(precedencesList[socketLink.naturalOrder] > 1) {
                  $scope.isActiveActive = true;
               }
            }
        }

        if(amountOfCatoLinks <= 1) {
            return;
        } else {
            if(changedPrecedences > 1) {
                $scope.isActivePassive = true;
            }
        }
    }

    $scope.updateNetworkInterface = function(socketInterface){
        if ($scope.site.socketConnectionConfiguration.socketsSettings.secondary) {
            var secondarySocketInter = $scope.site.socketConnectionConfiguration.socketsSettings.secondary.links.filter(function(link) { return link.interface_id === socketInterface.interface_id})[0];
            if (secondarySocketInter) {
                copyLinkSettings(socketInterface, secondarySocketInter);
            }
        }

        if (socketInterface) {
            setHostsDisabled(socketInterface);
        }

        if (socketInterface.destType.value === 'ALTERNATIVE' || (socketInterface.destType.value === 'LAYER_2_WAN')) {
            $scope.site.hasAlternativeWan = true;
        } else {
            $scope.site.hasAlternativeWan = $scope.site.socketConnectionConfiguration.socketInterfaces.filter(function(item) {
                return item.destType.value === 'ALTERNATIVE' || item.destType.value === 'LAYER_2_WAN';
            }).length > 0;
        }

        var networkInterface;
        $scope.site.interfaces.forEach(function(inter) {
            if (inter.interface_id === socketInterface.interface_id) {
                networkInterface = inter;
            }
        });



        if (SiteService.isLanBasedSocketInterface(socketInterface.destType)) {

            if (!networkInterface) {
                let networkInterfaceMetaData = $scope.site?.interfaces?.filter(ni => ni.metadata !== null)[0]?.metadata;
                let newNetworkInterface = SiteService.getNewNetworkInterface(socketInterface, networkInterfaceMetaData)
                $scope.site.interfaces.push(newNetworkInterface);
            }
        } else if (networkInterface){
            var index = 0;
            $scope.site.interfaces.forEach(function(inter) {
                if (inter.id === networkInterface.id) {
                    $scope.site.interfaces.splice(index, 1);
                }
                index++;
            });
        }

        $scope.clearErrors();
        $scope.precedenceChangeListener();
    };

//    $scope.showSdwanMutlitunnelMode = function(){
//        if (!$scope.site.socketConnectionConfiguration)
//            return;
//
//        return $scope.site && $scope.site.socketConnectionConfiguration.socketInterfaces &&
//               $scope.site.socketConnectionConfiguration.socketInterfaces.filter(function(item){return item.destType === 'CATO'}).length === 2;
//    };
//
    function setHostsDisabled(socketInterface) {
        $('#subnetTable').find('.interfaceName').filter(function(i, item) {
            return (item.attributes.interfaceId.value === socketInterface.interface_id)
        }).closest('tbody').attr('disabled', !SiteService.isLanBasedSocketInterface(socketInterface.destType) ? 'disabled' : false);
    }

    /**
     * getting the account life cycle status by site id,
     * the lifecycle if loaded once for the account since it
     * is joint for all sites
     * @param site
     */
    function updateCurrentLifecycleStatus(site) {
        if($scope.currentLifeCycleStatus)
            return;
        store.fetch({
            method: 'GET',
            path: "/getAccountLifecycleStatus",
            queryParams :{
                siteId: site.id
            },
            success: function(data) {
                $scope.currentLifeCycleStatus = data;
                initZones();
            }
        });
    }

    $scope.editTrigger = function(item,id){
        $scope.$root.$emit("$openPopup","localRoute","limit_" + id );
        $scope.scopeSelection = {"item":item};
    };

    $scope.showportprotocol = function(){
        $scope.showportprotocoltip = true;
        $timeout(function(){
            $tooltip.css({
                marginTop: -($tooltip.height()) - 10,
                marginLeft: -(($tooltip.width() / 2) - ($icon.width() / 2))
            });
        }, 1, false);
    };

    $scope.unAssignSocket = function(socket) {
        store.action({
            path: '/unAssignSocket?socketId=' + socket.id,
            success: function(data) {
            }
        });
    };

    $scope.identifySocket = function(socket) {
        store.action({
            path: '/identifySocket?socketId=' + socket.id,
            success: function(data) {
            }
        });
    };

    $scope.swapSocketsRoles = function(siteId) {
        store.action({
            path: '/swapSocketsRoles?siteId=' + siteId,
            success: function(data) {
                $scope.$root.handleServerResponse(data,"site", "Sockets HA primary switched");
                if(data.status !== "ERROR"){
                    showSite(data.model, true);
                }
            }
        })
    };

    function initBWManagementData() {
        $scope.catoSocketInterfaces = [];
        $scope.alternativeWanInterfaces = [];

        if ($scope.site && $scope.site.socketConnectionConfiguration &&
                $scope.site.socketConnectionConfiguration.socketInterfaces &&
                $scope.site.socketConnectionConfiguration.socketInterfaces.length > 0) {

            $scope.site.socketConnectionConfiguration.socketInterfaces.forEach(function (si) {
                if (si.destType.value == 'CATO') {
                    $scope.catoSocketInterfaces.push(si);
                } else if (si.destType.value == 'ALTERNATIVE') {
                    $scope.alternativeWanInterfaces.push(si);
                }
            });
        }
    };

    $scope.changeThresholdsDuration = function(site) {
        if (site.exceededThresholdsDurationEnabled) {
            site.exceededThresholdsDuration = {
                length: 1,
                unit: 'MINUTES'
            };
        } else {
            site.exceededThresholdsDuration = null;
        }
    }

    $scope.changeHigherNaturalOrder = function(site) {
        if (site.socketConnectionConfiguration.preferHigherNaturalOrder) {
            site.socketConnectionConfiguration.acceptableNaturalOrder = 1;
            if ($scope.$root.tags.includes('QOS_ALERTS')) {
                site.socketConnectionConfiguration.fallbackPrecedenceDuration = {
                    length: 10,
                    unit: 'MINUTES'
                };
                site.socketConnectionConfiguration.fallbackPrecedenceDurationFactor = 2;
            }
        } else {
            site.socketConnectionConfiguration.fallbackPrecedenceDuration = null;
            site.socketConnectionConfiguration.fallbackPrecedenceDurationFactor = null;
            site.socketConnectionConfiguration.acceptableNaturalOrder = null;
        }
    }

    $scope.openChangeFailOverFactorDlg = function(site) {
        site.socketConnectionConfiguration.fallbackPrecedenceDurationFactorEdited = site.socketConnectionConfiguration.fallbackPrecedenceDurationFactor;
        $scope.$root.openPopup('changeFailOverFactorDlg');
    }

    $scope.approveChangeFailOverFactorDlg = function(site) {
        site.socketConnectionConfiguration.fallbackPrecedenceDurationFactor = site.socketConnectionConfiguration.fallbackPrecedenceDurationFactorEdited;
        $scope.$root.closePopup('changeFailOverFactorDlg');
    }

    $scope.isBGPSupportedForSiteType = function() {
        return $scope.isSiteOfConnTypeFamily('IPSEC') || $scope.isSiteOfConnTypeFamily('SOCKET');
    };

    $scope.isSiteSupportSiteRecoveryPolicy = function(){
        return $scope.site && $scope.site.siteConnType.supportSiteRecovery;
    }

    $scope.isSocketTypeSupportSiteRecoveryPolicy = function(){
        var keys = Object.keys($scope.site.socketConnectionConfiguration.socketsSettings);
        for (var i=0; i < keys.length; i++) {
            if ($scope.site.socketConnectionConfiguration.socketsSettings[keys[i]].supportedFeatures.includes("ALT_WAN_RECOVERY")){
                return true;
            }
        }

        return false;
    };

    StaticRangeTranslationService.getStaticRangeTranslationEnabled($state.params.accountId,function (data) {
        $scope.staticRangeTranslationEnabled = data;
    });

    $scope.isStaticRangeTranslationDisabled = function(){
        return $scope.staticRangeTranslationEnabled != null && !$scope.staticRangeTranslationEnabled;
    }

    $scope.changeSiteName = function(site){
        store.save({
            path: "/changeSiteName",
            queryParams: {
                'siteId': site.id,
                'newName': site.name
            },
            success: function(data) {
                if (data.status !== "ERROR") {
                    $scope.$root.handleServerResponse(data, "" , 'Site name changed successfully');
                    $scope.$root.closePopup('changeSiteNameDlg');
                    showSite(data.model, true);
                }
                else {
                    $scope.$root.handleServerResponse(data, "");
                    site.name = $scope.orig.name;
                }
            }
        });
    };

    let doesSocketSupportOffCloudTransport = () => {
        for (const [key, socketSettings] of Object.entries($scope.site.socketConnectionConfiguration.socketsSettings)) {
            if (socketSettings.supportedFeatures.includes("INTERNET_TRANSPORT")){
                return true;
            }
        }
        return false;
    };

    let doesNicSupportOffCloudTransport = () => {
        for (const [key, socketSettings] of Object.entries($scope.site.socketConnectionConfiguration.socketsSettings)) {
            if (socketSettings.supportedFeatures.includes("OFF_CLOUD_FOR_CATO_NIC")){
                return true;
            }
        }
        return false;
    };

    let doesCountrySupportOffCloudTransport = () => {
        return $scope.site.countryRaw !== 'CN';
    };

    let doesPopRegionSupportOffCloudTransport = () => {
        return !$scope.site?.siteUsage?.region?.includes('China');
    };

    $scope.isOffCloudSupported = () => {
        return doesSocketSupportOffCloudTransport() && doesCountrySupportOffCloudTransport() && $scope.site.isOffCloudSupportedInAccount && doesPopRegionSupportOffCloudTransport()
    };

    $scope.isOffCloudSupportedInNic = () => {
        return doesNicSupportOffCloudTransport() && doesCountrySupportOffCloudTransport() && $scope.site.isOffCloudSupportedInAccount && doesPopRegionSupportOffCloudTransport()
    };

    $scope.getOffCloudNotSupportedMessage = () => {
        $scope.showOffCloudTransportIncompatibleSites = false;
        if(!doesCountrySupportOffCloudTransport()) {
            return 'This feature is currently not available in ' + $scope.countries[$scope.site.countryRaw].name;
        }
        if(!doesPopRegionSupportOffCloudTransport()) {
            return 'This feature is currently not available for sites in PoP Region ' + $scope.site.siteUsage.region;
        }
        if(!doesSocketSupportOffCloudTransport()) {
            return 'This feature is only supported for a site with Socket version 7.0.0';
        }
        if(!$scope.site.isOffCloudSupportedInAccount) {
            $scope.showOffCloudTransportIncompatibleSites = true;
            return 'To enable this feature, all Sockets in the account must be Socket version 6.1.3473 or higher'
        }
    };

    $scope.openIncompatibleSitesForOffcloudTransportDlg = function() {
        if (!$scope.site.isOffCloudSupportedInAccount){
            $scope.propertiesModified = new Date();
            $scope.$root.openPopup('incompatibleSitesForOffcloudTransportDlg');
        }
    };

    $scope.offCloudTransportIncompatibleSitesCfg = {
        defer: true,
        dataURL: function() {
            return '/getSiteForNonSupportedSocketFeatureType?accountId=' + $state.params.accountId + '&featureType=INTERNET_TRANSPORT';
        },
        fields: [
            {"label": "Name", "path": "name", "template": "<span>{{item.name}}</span>"},
            {"label": "Socket Version", "path": "socketVersion", "template": "<span>{{item.socketVersion | socketVersion }}</span>"},
            {"label": "Type", "path": "siteType", "template": "<span>{{item.siteType | capitalize }}</span>"},
        ],
        pageSize: 8,
        titleSearch: "Name",
        sortField: "name",
        searchField: "name",
        type: "Site",
        hideCheckboxes: true,
        clientSidePaging: true,
        clientSideSearch: true,
        clientSideSort: true
    };

    $scope.showNetwork = (siteInterface) => {
        return !siteInterface.socketInterface || siteInterface.socketInterface.destType.value === 'INTERFACE_DISABLED' || SiteService.isLanBasedSocketInterface(siteInterface.socketInterface.destType);
    }

    $scope.shouldShowLinkToManagementIp = () => {
        return $scope.site.socketConnectionConfiguration.socketsSettings.primary.managementIP &&
            $scope.site.socketConnectionConfiguration.socketsSettings.secondary.managementIP &&
            $scope.site.socketConnectionConfiguration.socketsSettings.primary.deviceId &&
            $scope.site.socketConnectionConfiguration.socketsSettings.secondary.deviceId;
    }

    $scope.getManagementIpName = (site) => {
        return isSiteSocketType(site, 'SOCKET_AZ1500') ? $scope.vSOCKET_MANAGEMENT_IP_NAME : DEFAULT_MANAGEMENT_IP_NAME;
    }

    $scope.isUnassignSupported = () => {
        return ($scope.isSiteOfConnTypeFamily('vSOCKET') && !isDummySocket()) || isFeatureSupportedOnSite('UNASSIGN_SOCKET');
    }

    $scope.isHaSite = (site) => {
        return site.socketConnectionConfiguration.socketsSettings.secondary;
    }

    const isSiteSocketType = (site, type) => {
        return site?.siteConnType?.protoType === type;
    }

    const isFeatureSupportedOnSite = (featureType) => {
        return $scope.site?.socketConnectionConfiguration?.socketsSettings?.primary?.supportedFeatures.indexOf(featureType) >= 0;
    }

    $scope.shouldShowSerialLabel = () => {
        return !isDummySocket();
    }

    const isDummySocket = () => {
        return !$scope.site?.socketConnectionConfiguration?.socketsSettings?.primary?.id || $scope.site.socketConnectionConfiguration.socketsSettings.primary.id === -1;
    }

    const updateManagementIpsAfterSaveForAwsHaSites = (site) => {
        if (isSiteSocketType(site,'SOCKET_AWS1500') && $scope.isHaSite(site)){
            $scope.updatePrimaryLocalIp();
            $scope.updateSecondaryLocalIp();
        }
    }

    $scope.updatePrimaryLocalIp = () => {
        $scope.site.interfaces[0].localIp = $scope.site?.socketConnectionConfiguration?.socketsSettings?.primary?.managementIP;
    }

    $scope.updateSecondaryLocalIp = () => {
        $scope.site.interfaces[0].subnets.filter(subnet => subnet.subnetType.value === 'SECONDARY_NATIVE')[0].localIp = $scope.site?.socketConnectionConfiguration?.socketsSettings?.secondary?.managementIP;
    }

    $scope.openSocketUI = (socketDeviceId) => {
        return SocketUIService.openSocketUI(socketDeviceId,$state.params.accountId);
    }

    /**
     * Show SLA settings if the site is of socket type
     */
    $scope.showSlaSetting = () => {
        return $scope.site?.siteConnType?.socketModelTypeConfiguration;
    }

    $scope.isSiteOfConnTypeFamily = (connectionType) => {
        return $scope.site?.siteConnType?.connectionTypeFamilies?.some(type => type === connectionType);
    }
}

